export const translator = {
  localhost3000: "http://localhost:3000",
  localhost3001: "http://localhost:3001",
  localhost3002: "http://localhost:3002",
  baseURL: process?.env?.REACT_APP_API_ENDPOINT || "https://dev.makemylabs.in",
  qaBaseURL: "https://qa.makemylabs.co.in",
  prefBaseURL: "https://perf.makemylabs.co.in",
  stageBaseURL: "https://stage.makemylabs.in",
  prodBaseURL: "https://laas.makemylabs.in",
  uatBaseURL: "https://uat.makemylabs.in",
  hotfixBaseURL: "https://hotfix.makemylabs.co.in",
  userListParamsSuffix: "/v1/users",
  tenantListParamsSuffix: "/v1/tenants",
  tenantDeleteParamsSuffix: "/v1/tenants/",
  tenantPauseParamsSuffix: "/v1/tenants/",
  wsUrl:
    process?.env?.REACT_APP_WEBSOCKET_ENDPOINT || "wss://dev.makemylabs.in",
};

export const dashboardActions = {
  apiAction: "FETCH_DATA",
  apiActionSet: "SET_DATA",
  apiActionError: "FETCH_DATA_ERRPR",
  fetchDashboardSuccess: "FETCH_DASHBOARD_SUCCESS",
  fetchDashboardFailure: "FETCH_DASHBOARD_FAILURE",
  getResourceProviderDashboard: "GET_RESOURCE_PROVIDER_LIST_DASHBOARD",
  resourceProviderDashboardSuccess:
    "FETCH_RESOURCE_PROVIDER_LIST_DASHBOARD_SUCCESS",
  resourceProviderDashboardError:
    "FETCH_RESOURCE_PROVIDER_LIST_DASHBOARD_ERROR",
  getResourcesInfoDashboard: "GET_RESOURCES_INFO_DASHBOARD",
  resourcesInfoDashboardSuccess: "FETCH_RESOURCES_INFO_DASHBOARD_SUCCESS",
  resourcesInfoDashboardError: "FETCH_RESOURCES_INFO_DASHBOARD_ERROR",
  setLoadingDashboard: "SET_LOADING_DASHBOARD",
  setloadingResourcesInfo: "SET_LOADING_RESOURCES_DASHBOARD",
  getTenantsStatsDashboard: "GET_TENANT_STATS_DASHBOARD",
  tenantDashboardSuccess: "FETCH_TENANT_STATS_DASHBOARD_SUCCESS",
  tenantDashboardError: "FETCH_TENANT_STATS_DASHBOARD_ERROR",
  getUserStatsDashboard: "GET_USER_STATS_DASHBOARD",
  userDashboardSuccess: "FETCH_USER_STATS_DASHBOARD_SUCCESS",
  userDashboardError: "FETCH_USER_STATS_DASHBOARD_ERROR",
  getUserDropDownDashboard: "GET_USERS_DROPDOWN_DASHBOARD",
  userDropdownDashboardSuccess: "FETCH_USER_DROPDOWN_DASHBOARD_SUCCESS",
  userDropdownDashboardError: "FETCH_USER_DROPDOWN_DASHBOARD_ERROR",
  usersListSearching: "SET_USERLIST_LOADING_DASHBOARD",
  getPendingActions: "GET_PENDING_ACTIONS_DASHBOARD_SUCCESS",
  pendingActionsDashboardSuccess: "FETCH_PENDING_ACTION_DASHBOARD_SUCCESS",
  pendingActionsDashboardError: "FETCH_PENDING_ACTION_DASHBOARD_ERROR",
  setResProviderListLoading: "SET_LOADING_RESPROVIDERLIST",
  setLoadingDashboardTenStats: "SET_LOADING_DASHBOARD_TENNATSSTAT",
  setLoadingDashboardUserStats: "SET_LOADING_DASHBOARD_USER_STATS",
  setPendingActionLoading: "SET_LOADING_DASHBOARD_PENDING_ACTION",
  getVMStats: "GET_VMSTATS_DASHBOARD",
  vmStatsSuccess: "FETCH_VM_STATS_DASHBOARD_SUCCESS",
  vmStatsError: "FETCH_VM_STATS_DASHBOARD_ERROR",
  setLoadingDashboardVMStats: "SET_LOADING_DASHBOARD_VM_STATS",
  getVMStatsTenantUserDashboard: "GET_VM_STATS_TENANT_USER_DASHBOARD",
  resetProviderList: "RESET_DASHBOARD_RESOURCE_PROVIDERLIST",

  setLoadingDashboardBillingInfoLast: "SET_LOADING_DASHBOARD_BILLING_INFO_LAST",
  setLoadingDashboardBillingInfoCurr: "SET_LOADING_DASHBOARD_BILLING_INFO_CURR",
  getBillingStatsDashboardLastMonth: "GET_BILLING_STATS_DASHBOARD_LAST_MONTH",
  getBillingStatsDashboardCurrMonth: "GET_BILLING_STATS_DASHBOARD_CURR_MONTH",
  billingStatsCurrMonthDashboardSuccess:
    "FETCH_BILLING_STATS_CURR_MONTH_DASHBOARD_SUCCESS",
  billingStatsLastMonthDashboardSuccess:
    "FETCH_BILLING_STATS_LAST_MONTH_DASHBOARD_SUCCESS",

  billingStatsDashboardError: "FETCH_BILLING_STATS_DASHBOARD_ERROR",

  setLoadingAllVMs: "SET_LOADING_DASHBOARD_ALLVMS",
  getAllVMs: "GET_ALL_VMS_DASHBOARD",
  ALLVMsDashboardSuccess: "FETCH_ALL_VMS_DASHBOARD_SUCCESS",
  ALLVMsDashboardError: "FETCH_ALL_VMS_DASHBOARD_ERROR",
  UPDATE_DASHBOARD_VM_STATE: "UPDATE_DASHBOARD_VM_STATE",

  setLoadingAllTrendLabs: "SET_LOADING_DASHBOARD_ALL_TRENDING_LABS",
  getAllTrendingLabs: "GET_ALL_TRENDING_LABS_DASHBOARD",
  ALLTrendingLabsDashboardSuccess: "FETCH_ALL_TRENDING_LABS_DASHBOARD_SUCCESS",
  ALLTrendingLabsDashboardError: "FETCH_ALL_TRENDING_LABS_DASHBOARD_ERROR",

  setLoadingUsageTrends: "SET_LOADING_DASHBOARD_USAGE_TRENDS",
  getDashboardUsageDailyTrends: "GET_USAGE_TRENDS_DAILY_DASHBOARD",
  getDashboardUsageWeeklyTrends: "GET_USAGE_TRENDS_WEEKLY_DASHBOARD",
  usageTrendsDashboardDailySuccess:
    "FETCH_USAGE_TRENDS_DASHBOARD_DAILY_SUCCESS",
  usageTrendsDashboardWeeklySuccess:
    "FETCH_USAGE_TRENDS_DASHBOARD_WEEKLY_SUCCESS",
  usageTrendsDashboardError: "FETCH_USAGE_TRENDS_DASHBOARD_ERROR",
  setLoadingUsageHours: "SET_LOADING_DASHBOARD_USAGE_HOURS",
  getDashboardUsageHours: "GET_USAGE_HOURS_DASHBOARD",
  UsageHoursDashboardSuccess: "FETCH_USAGE_HOURS_DASHBOARD_SUCCESS",
  UsageHoursDashboardError: "FETCH_USAGE_HOURS_DASHBOARD_ERROR",
  setLoadingForecast: "SET_LOADING_DASHBOARD_FORECAST",
  getDashboardForecast: "GET_DASHBOARD_FORECAST",
  forecastDashboardSuccess: "FORECAST_DASHBOARD_SUCCESS",
  forecastDashboardError: "FORECAST_DASHBOARD_ERROR",

  RESOURSE_PROVIDER_COUNT_LOADING: "RESOURSE_PROVIDER_COUNT_LOADING",
  RESOURSE_PROVIDER_COUNT_ACTION: "RESOURSE_PROVIDER_COUNT_ACTION",
  RESOURSE_PROVIDER_COUNT_SUCCESS: "RESOURSE_PROVIDER_COUNT_SUCCESS",
  RESOURSE_PROVIDER_COUNT_ERROR: "RESOURSE_PROVIDER_COUNT_ERROR",
  RESOURSE_PROVIDER_COUNT_RESET: "RESOURSE_PROVIDER_COUNT_RESET",
};

export const userManagementActions = {
  userManagementUploadRequest: "USER_MANAGEMENT_UPLOAD_REQUEST",
  userManagementUploadSuccess: "USER_MANAGEMENT_UPLOAD_SUCCESS",
  userManagementUploadError: "USER_MANAGEMENT_UPLOAD_ERROR",
  userListGetData: "USERLIST_FETCH_DATA",
  allUserListGetData: "ALL_USERLIST_FETCH_DATA",
  userListGetDataPaginated: "USERLIST_FETCH_DATA_PAGINATED",
  userListSetData: "USERLIST_SET_DATA",
  allUserListSetData: "ALL_USERLIST_SET_DATA",
  userListSetDataPaginated: "USERLIST_SET_DATA_PAGINATED",
  userListResetDataPaginated: "USERLIST_RESET_DATA_PAGINATED",
  userListSetError: "USERLIST_FETCH_DATA_ERROR",
  allUserListSetError: "ALL_USERLIST_FETCH_DATA_ERROR",
  userActionDataSuccess: "USER_ACTION_DATA_SUCCESS",
  userManagementDeleteUser: "USER_MANAGEMENT_DELETE_USER",
  USER_MNGMNT_DELETE_USER_SUCCESS: "USER_MNGMNT_DELETE_USER_SUCCESS",
  suspendUser: "SUSPEND_USER",
  userManagementCreateUserRequest: "USER_MANAGEMENT_CREATE_USER_REQUEST",
  userManagementCreateUserSuccess: "USER_MANAGEMENT_CREATE_USER_SUCCESS",
  userManagementEditUserRequest: "USER_MANAGEMENT_EDIT_USER_REQUEST",
  userManagementEditUserSuccess: "USER_MANAGEMENT_EDIT_USER_SUCCESS",
  userManagementEditUserError: "USER_MANAGEMENT_EDIT_USER_ERROR",
  userManagementUpdateUserRequest: "USER_MANAGEMENT_UPDATE_USER_REQUEST",
  userManagementUpdateUserSuccess: "USER_MANAGEMENT_UPDATE_USER_SUCCESS",
  userManagementUpdateUserError: "USER_MANAGEMENT_UPDATE_USER_ERROR",
  defaultRolesRequest: "USER_DEFAULT_ROLES_REQUEST",
  defaultRolesSuccess: "USER_DEFAULT_ROLES_SUCCESS",
  assignRolesRequest: "USER_ASSIGN_ROLES_REQUEST",
  assignRolesSuccess: "USER_ASSIGN_ROLES_SUCCESS",
  bussinessUnitRequest: "USER_BUSINESS_UNIT_REQUEST",
  businessUnitSuccess: "USER_BUSINESS_UNIT_SUCCESS",
  retrieveUserDetail: "RETRIEVE_USER_DETAIL",
  setUserDetail: "SET_USER_DETAIL",
  REMOVE_SELECTED_USER_DETAILS: "REMOVE_SELECTED_USER_DETAILS",
  ERROR_CREATE_USER: "ERROR_CREATE_USER",
  userListSetLoading: "USER_LIST_SET_LOADING",

  ACTIVE_USER_DOWNLOAD_LOADING: "ACTIVE_USER_DOWNLOAD_LOADING",
  ACTIVE_USER_DOWNLOAD_ACTION: "ACTIVE_USER_DOWNLOAD_ACTION",
  ACTIVE_USER_DOWNLOAD_SUCCESS: "ACTIVE_USER_DOWNLOAD_SUCCESS",
  ACTIVE_USER_DOWNLOAD_ERROR: "ACTIVE_USER_DOWNLOAD_ERROR",
  ACTIVE_USER_DOWNLOAD_RESET: "ACTIVE_USER_DOWNLOAD_RESET",
};

export const tenantManagementActions = {
  tenantCreateRequest: "TENANT_CREATE_REQUEST",
  tenantCreateSuccess: "TENANT_CREATE_SUCCESS",
  tenantEditRequest: "TENANT_EDIT_REQUEST",
  tenantEditSuccess: "TENANT_EDIT_SUCCESS",
  tenantListGetData: "TENANTLIST_FETCH_DATA",
  tenantListSetData: "TENANTLIST_SET_DATA",
  tenantListSetError: "TENANTLIST_FETCH_DATA_ERROR",
  tenantDeleteData: "TENANT_DELETE_DATA",
  tenantDeleteSuccess: "TENANT_DELETE_SUCCESS",
  tenantActionSuccess: "TENANT_ACTION_SUCCESS",
  tenantDeleteError: "TENANT_DELETE_ERROR",
  tenantPlayPauseData: "TENANT_PLAY_PAUSE_DATA",
  tenantPlayPauseError: "TENANT_PLAY_PAUSE_ERROR",
  tenantViewRequest: "TENANT_VIEW_REQUEST",
  tenantViewSuccess: "TENANT_VIEW_SUCCESS",
  UPLOAD_TENANT_LOGO: "UPLOAD_TENANT_LOGO",
  UPLOAD_TENANT_LOGO_SUCCESS: "UPLOAD_TENANT_LOGO_SUCCESS",
  UPLOAD_TENANT_LOGO_ERROR: "UPLOAD_TENANT_LOGO_ERROR",
  GET_ACCOUNT_MANAGER_LIST: "GET_ACCOUNT_MANAGER_LIST",
  SET_ACCOUNT_MANAGER_LIST: "SET_ACCOUNT_MANAGER_LIST",
  ACCOUNT_MANAGER_LIST_ERROR: "ACCOUNT_MANAGER_LIST_ERROR",
  GET_CSM_ADMIN_LIST: "GET_CSM_ADMIN_LIST",
  SET_CSM_ADMIN_LIST: "SET_CSM_ADMIN_LIST",
  CSM_ADMIN_LIST_ERROR: "CSM_ADMIN_LIST_ERROR",
  GET_MACHINE_CATALOG_LIST: "GET_MACHINE_CATALOG_LIST",
  SET_MACHINE_CATALOG_LIST: "SET_MACHINE_CATALOG_LIST",
  MACHINE_CATALOG_LIST_ERROR: "MACHINE_CATALOG_LIST_ERROR",
  TENANT_CREATION_SUCCESS: "TENANT_CREATION_SUCCESS",
  GET_TENANT_DETAILS_BY_ID: "GET_TENANT_DETAILS_BY_ID",
  SET_TENANT_DETAILS_BY_ID: "SET_TENANT_DETAILS_BY_ID",
  SET_TENANT_DETAILS_ERROR_BY_ID: "SET_TENANT_DETAILS_ERROR_BY_ID",
  REQUEST_PRICING_PROFILE: "REQUEST_PRICING_PROFILE",
  SUCCESS_PRICING_PROFILE: "SUCCESS_PRICING_PROFILE",
  ERROR_PRICING_PROFILE: "ERROR_PRICING_PROFILE",
  SET_QUOTA_FORM_REQUEST: "SET_QUOTA_FORM_REQUEST",
  SET_QUOTA_FORM_SUCCESS: "SET_QUOTA_FORM_SUCCESS",
  SET_QUOTA_FORM_GET_REQUEST: "SET_QUOTA_FORM_GET_REQUEST",
  SET_QUOTA_FORM_GET_SUCCESS: "SET_QUOTA_FORM_GET_SUCCESS",
  SET_QUOTA_FORM_UPDATE_REQUEST: "SET_QUOTA_FORM_UPDATE_REQUEST",
  SET_QUOTA_FORM_UPDATE_SUCCESS: "SET_QUOTA_FORM_UPDATE_SUCCESS",
  NOTIFICATION_SETTINGS_FORM_REQUEST: "NOTIFICATION_SETTINGS_FORM_REQUEST",
  NOTIFICATION_SETTINGS_FORM_SUCCESS: "NOTIFICATION_SETTINGS_FORM_SUCCESS",
  NOTIFICATION_SETTINGS_GET_REQUEST: "NOTIFICATION_SETTINGS_GET_REQUEST",
  NOTIFICATION_SETTINGS_GET_SUCCESS: "NOTIFICATION_SETTINGS_GET_SUCCESS",
  NOTIFICATION_SETTINGS_UPDATE_REQUEST: "NOTIFICATION_SETTINGS_UPDATE_REQUEST",
  NOTIFICATION_SETTINGS_UPDATE_SUCCESS: "NOTIFICATION_SETTINGS_UPDATE_SUCCESS",
  PRICING_PROFILE_CREATE_REQUEST: "PRICING_PROFILE_CREATE_REQUEST",
  PRICING_PROFILE_CREATE_SUCCESS: "PRICING_PROFILE_CREATE_SUCCESS",
  PRICING_PROFILE_CREATE_ERROR: "PRICING_PROFILE_CREATE_ERROR",
  PRICING_PROFILE_EDIT_REQUEST: "PRICING_PROFILE_EDIT_REQUEST",
  PRICING_PROFILE_EDIT_SUCCESS: "PRICING_PROFILE_EDIT_SUCCESS",
  PRICING_PROFILE_EDIT_ERROR: "PRICING_PROFILE_EDIT_ERROR",
  GET_TENANT_FORM_SUMMARY: "GET_TENANT_FORM_SUMMARY",
  SET_TENANT_FORM_SUMMARY: "SET_TENANT_FORM_SUMMARY",
  EXTENSION_FORM_CREATE: "EXTENSION_FORM_CREATE",
  SET_EXTENSION_FORM_CREATE: "SET_EXTENSION_FORM_CREATE",
  EXTENSION_FORM_UPDATE: "EXTENSION_FORM_UPDATE",
  SET_EXTENSION_FORM_UPDATE: "SET_EXTENSION_FORM_UPDATE",
  GET_EXTENSION_FORM_DATA: "GET_EXTENSION_FORM_DATA",
  SET_EXTENSION_FORM_DATA: "SET_EXTENSION_FORM_DATA",
  SET_EXTENSION_FORM_ERROR: "SET_EXTENSION_FORM_ERROR",
  SET_EXTENSION_FORM_CREATE_ERROR: "SET_EXTENSION_FORM_CREATE_ERROR",
  SET_EXTENSION_FORM_UPDATE_ERROR: "SET_EXTENSION_FORM_UPDATE_ERROR",
  UPLOAD_HTML_TEMPLATE_REQUEST: "UPLOAD_HTML_TEMPLATE_REQUEST",
  UPLOAD_HTML_TEMPLATE_SUCCESS: "UPLOAD_HTML_TEMPLATE_SUCCESS",
  UPLOAD_HTML_TEMPLATE_ERROR: "UPLOAD_HTML_TEMPLATE_ERROR",
  HTML_TEMPLATE_FETCH_LIST_REQUEST: "HTML_TEMPLATE_FETCH_LIST_REQUEST",
  HTML_TEMPLATE_FETCH_LIST_SUCCESS: "HTML_TEMPLATE_FETCH_LIST_SUCCESS",
  HTML_TEMPLATE_FETCH_LIST_ERROR: "HTML_TEMPLATE_FETCH_LIST_ERROR",
  SET_TENANT_FORM_SUMMARY_ERROR: "SET_TENANT_FORM_SUMMARY_ERROR",
  GET_TENANT_SETTINGS_DATA: "GET_TENANT_SETTINGS_DATA",
  SET_TENANT_SETTINGS_DATA: "SET_TENANT_SETTINGS_DATA",
  SET_TENANT_SETTINGS_ERROR: "SET_TENANT_SETTINGS_ERROR",
  SET_TENANT_LIST_LOADING: "SET_TENANT_LIST_LOADING",
  SET_TENANT_LIST_PAGINATION: "SET_TENANT_LIST_PAGINATION",
  RESET_TENANT_LIST_PAGINATION: "RESET_TENANT_LIST_PAGINATION",
  GET_TENANT_LIST_PAGINATED: "GET_TENANT_LIST_PAGINATED",
};

export const rbacManagementActions = {
  ROLESLISTGETDATA: "ROLESLIST_FETCH_DATA",
  ROLESLISTSETDATA: "ROLESLIST_SET_DATA",
  ROLESLISTSETERROR: "ROLESLIST_SET_ERROR",
  PERMISSIONSLISTGETDATA: "PERMISSIONSLIST_FETCH_DATA",
  PERMISSIONSLISTSETDATA: "PERMISSIONSLIST_SET_DATA",
  PERMISSIONSLISTSETERROR: "PERMISSIONSLIST_SET_ERROR",
  ROLEPERMISSIONSGETDATA: "ROLEPERMISSIONS_FETCH_DATA",
  ROLEPERMISSIONSSETDATA: "ROLEPERMISSIONS_SET_DATA",
  ROLEPERMISSIONSSETERROR: "ROLEPERMISSIONS_SET_ERROR",
  ROLEPERMISSIONSEDITREQUEST: "ROLE_PERMISSIONS_EDIT_REQUEST",
  ROLEPERMISSIONSEDITSUCCESS: "ROLE_PERMISSIONS_EDIT_SUCCESS",
  ROLEPERMISSIONSEDITERROR: "ROLE_PERMISSIONS_EDIT_ERROR",
  USER_ACTION_SUCCESS: "USER_ACTION_SUCCESS",
  DELETE_ACTION_DATA: "DELETE_ACTION_DATA",
  CREATENEWROLEREQUEST: "CREATE_NEW_ROLE_REQUEST",
  CREATENEWROLEERROR: "CREATE_NEW_ROLE_ERROR",
  FETCH_CLONE_ROLES: "FETCH_CLONE_ROLES",
  SET_CLONE_ROLES: "SET_CLONE_ROLES",
  DELETE_ROLE: "DELETE_ROLE",
  DELETE_ROLE_SUCCESS: "DELETE_ROLE_SUCCESS",
  DELETE_ROLE_ERROR: "DELETE_ROLE_ERROR",
  GET_RESOURCE_PERMISSIONS: "GET_RESOURCE_PERMISSIONS",
  SET_RESOURCE_PERMISSIONS: "SET_RESOURCE_PERMISSIONS",
  SET_RESOURCE_PERMISSIONS_ERROR: "SET_RESOURCE_PERMISSIONS_ERROR",
  ERROR_USER_ACTION_DATA: "ERROR_USER_ACTION_DATA",
};

export const resourceManagerActions = {
  RESOURCE_PROVIDER_LIST_GET_DATA: "RESOURCE_PROVIDER_LIST_FETCH_DATA",
  RESOURCE_PROVIDER_LIST_SET_DATA: "RESOURCE_PROVIDER_LIST_SET_DATA",
  RESOURCE_PROVIDER_LIST_SET_DATA_PUBLIC:
    "RESOURCE_PROVIDER_LIST_SET_DATA_PUBLIC",
  RESOURCE_PROVIDER_LIST_SET_ERROR: "RESOURCE_PROVIDER_LIST_SET_ERROR",
  RESOURCE_PROVIDER_LIST_SET_ERROR_PUBLIC:
    "RESOURCE_PROVIDER_LIST_SET_ERROR_PUBLIC",
  ADD_RESOURCE_CONNECTION: "ADD_RESOURCE_CONNECTION",
  SET_CONNECTION_DATA: "SET_CONNECTION_DATA",
  EDIT_RESOURCE_ACCOUNT: "EDIT_RESOURCE_ACCOUNT",
  ADD_RESOURCE_ACCOUNT: "ADD_RESOURCE_ACCOUNT",
  ADD_RESOURCE_ACTION: "ADD_RESOURCE_ACTION",
  EDIT_RESOURCE_ACTION: "EDIT_RESOURCE_ACTION",
  SET_RESOURCE_PROVIDER_ERROR: "SET_RESOURCE_PROVIDER_ERROR",
  DELETE_RESOURCE_REQUEST: "DELETE_RESOURCE_REQUEST",
  DELETE_RESOURCE_SUCCESS: "DELETE_RESOURCE_SUCCESS",
  DELETE_RESOURCE_ERROR: "DELETE_RESOURCE_ERROR",
  TEMPLATE_CREATE_REQUEST: "TEMPLATE_CREATE_REQUEST",
  PUBLIC_TEMPLATE_CREATE_REQUEST: "PUBLIC_TEMPLATE_CREATE_REQUEST",
  PUBLIC_TEMPLATE_PATCH_REQUEST: "PUBLIC_TEMPLATE_PATCH_REQUEST",
  TEMPLATE_CREATE_SUCCESS: "TEMPLATE_CREATE_SUCCESS",
  TEMPLATE_CREATE_ERROR: "TEMPLATE_CREATE_ERROR",
  TEMPLATE_EDIT_REQUEST: "TEMPLATE_EDIT_REQUEST",
  PUBLIC_TEMPLATE_EDIT_REQUEST: "PUBLIC_TEMPLATE_EDIT_REQUEST",
  TEMPLATE_EDIT_SUCCESS: "TEMPLATE_EDIT_SUCCESS",
  SET_CATEGORY_DATA: "SET_CATEGORY_DATA",
  GET_CATEGORY_DATA: "GET_CATEGORY_DATA",
  SET_CATEGORY_ERROR: "SET_CATEGORY_ERROR",
  SET_INSTANCE_DATA: "SET_INSTANCE_DATA",
  SET_CATEGORY_LIST_SEARCHING: "SET_CATEGORY_LIST_SEARCHING",
  SET_INSTANCE_LIST_SEARCHING: "SET_INSTANCE_LIST_SEARCHING",
  GET_CATEGORY_DATA_INFINITE_SCROLL: "GET_CATEGORY_DATA_INFINITE_SCROLL",
  SET_CATEGORY_DATA_INFINITE_SCROLL: "SET_CATEGORY_DATA_INFINITE_SCROLL",
  RESET_CATEGORY_DATA_INFINITE_SCROLL: "RESET_CATEGORY_DATA_INFINITE_SCROLL",
  RESET_INSTANCE_DATA_INFINITE_SCROLL: "RESET_INSTANCE_DATA_INFINITE_SCROLL",
  SET_INSTANCE_ERROR: "SET_INSTANCE_ERROR",
  DELETE_INSTANCE_SIZE: "DELETE_INSTANCE_SIZE",
  DELETE_INSTANCE_SIZE_SUCCESS: "DELETE_INSTANCE_SIZE_SUCCESS",
  DELETE_INSTANCE_SIZE_ERROR: "DELETE_INSTANCE_SIZE_ERROR",
  GET_INSTANCE_DATA: "GET_INSTANCE_DATA",
  GET_INSTANCE_DATA_INFINITE_SCROLL: "GET_INSTANCE_DATA_INFINITE_SCROLL",
  SET_INSTANCE_DATA_INFINITE_SCROLL: "SET_INSTANCE_DATA_INFINITE_SCROLL",
  SET_INSTANCE_SIZE: "SET_INSTANCE_SIZE",
  SET_INSTANCE_SIZE_SUCESS: "SET_INSTANCE_SIZE_SUCCESS",
  SET_INSTANCE_SIZE_ERROR: "SET_INSTANCE_SIZE_ERROR",
  SET_VM_SNAPSHOT_DATA: "SET_VM_SNAPSHOT_DATA",
  SET_VM_SNAPSHOT_ERROR: "SET_VM_SNAPSHOT_ERROR",
  GET_VM_SNAPSHOT_DATA: "GET_VM_SNAPSHOT_DATA",
  TEMPLATE_LIST_GET_DATA: "TEMPLATE_LIST_GET_DATA",
  TEMPLATE_LIST_SET_DATA: "TEMPLATE_LIST_SET_DATA",
  TEMPLATE_LIST_SET_ERROR: "TEMPLATE_LIST_SET_ERROR",
  TEMPLATE_SET_DATA: "TEMPLATE_SET_DATA",
  TEMPLATE_GET_DATA: "TEMPLATE_GET_DATA",
  TEMPLATE_GET_DATA_PUBLIC: "TEMPLATE_GET_DATA_PUBLIC",
  DELETE_TEMPLATE_REQUEST: "DELETE_TEMPLATE_REQUEST",
  DELETE_PUBLIC_TEMPLATE_REQUEST: "DELETE_PUBLIC_TEMPLATE_REQUEST",
  DELETE_TEMPLATE_SUCCESS: "DELETE_TEMPLATE_SUCCESS",
  PUBLISH_TEMPLATE: "PUBLISH_TEMPLATE",
  PUBLISH_POOLED_TEMPLATE: "PUBLISH_POOLED_TEMPLATE",
  PUBLISH_TEMPLATE_ERROR: "PUBLISH_TEMPLATE_ERROR",
  PUBLISH_TEMPLATE_ACTION: "PUBLISH_TEMPLATE_ACTION",
  UPLOAD_LOGO: "UPLOAD_LOGO",
  SET_LOGO_DATA: "SET_LOGO_DATA",
  UPLOAD_LOGO_ERROR: "UPLOAD_LOGO_ERROR",
  TOGGLE_VT_ENABLED: "TOGGLE_VT_ENABLED",
  TOGGLE_VT_ENABLED_SUCCESS: "TOGGLE_VT_ENABLED_SUCCESS",
  TOGGLE_VT_ENABLED_ERROR: "TOGGLE_VT_ENABLED_ERROR",
  RESOURCE_PROVIDER_GET_DETAILS: "RESOURCE_PROVIDER_GET_DETAILS",
  RESOURCE_PROVIDER_GET_DETAILS_PUBLIC: "RESOURCE_PROVIDER_GET_DETAILS_PUBLIC",
  GET_PUBLIC_TEMPLATE_LIST: "GET_PUBLIC_TEMPLATE_LIST",
  RESOURCE_PROVIDER_SET_DETAILS: "RESOURCE_PROVIDER_SET_DETAILS",
  RESOURCE_PROVIDER_SET_ERROR: "RESOURCE_PROVIDER_SET_ERROR",
  TEMPLATE_EXPORT_REQUEST: "TEMPLATE_EXPORT_REQUEST",
  TEMPLATE_EXPORT_SUCCESS: "TEMPLATE_EXPORT_SUCCESS",
  TEMPLATE_EXPORT_ERROR: "TEMPLATE_EXPORT_ERROR",
  CLEAR_TEMPLATE_EXPORT: "CLEAR_TEMPLATE_EXPORT",
  TEMPLATE_RECOVER_REQUEST: "TEMPLATE_RECOVER_REQUEST",
  TEMPLATE_RECOVER_SUCCESS: "TEMPLATE_RECOVER_SUCCESS",
  TEMPLATE_RECOVER_ERROR: "TEMPLATE_RECOVER_ERROR",
  SET_VM_SNAPSHOT_NAMES_LIST: "SET_VM_SNAPSHOT_NAMES_LIST",
  SET_VM_NAMES_LIST: "SET_VM_NAMES_LIST",
  GET_VCENTER_RESOURCES: "GET_VCENTER_RESOURCES",
  SET_VM_NAMES_LIST_LOADING: "SET_VM_NAMES_LIST_LOADING",
  SET_VM_SNAPSHOT_NAMES_LIST_LOADING: "SET_VM_SNAPSHOT_NAMES_LIST_LOADING",
  SET_VM_NETWORK_LIST: "SET_VM_NETWORK_LIST",
  SET_VM_NETWORK_LIST_LOADING: "SET_VM_NETWORK_LIST_LOADING",
  SET_VM_FOLDER_LIST_LOADING: "SET_VM_FOLDER_LIST_LOADING",
  GET_VCENTER_RESOURCES_NETWORK: "GET_VCENTER_RESOURCES_NETWORK",
  ADD_PUBLIC_CLOUD_PROVIDER: "ADD_PUBLIC_CLOUD_PROVIDER",
  EDIT_PUBLIC_CLOUD_PROVIDER: "EDIT_PUBLIC_CLOUD_PROVIDER",
  PATCH_PUBLIC_CLOUD_PROVIDER: "PATCH_PUBLIC_CLOUD_PROVIDER",
  GET_PUBLIC_CLOUD_PROVIDER_LIST: "GET_PUBLIC_CLOUD_PROVIDER_LIST",
  LIST_AFTER_PATCH_PUBLIC_PROVIDER: "LIST_AFTER_PATCH_PUBLIC_PROVIDER",
  DELETE_PUBLIC_PROVIDER: "DELETE_PUBLIC_PROVIDER",
  DELETE_PUBLIC_PROVIDER_SUCCESS: "DELETE_PUBLIC_PROVIDER_SUCCESS",

  ADD_PUBLIC_PROVIDER_ERROR: "ADD_PUBLIC_PROVIDER_ERROR",
  ADD_PUBLIC_PROVIDER_SUCCESS: "ADD_PUBLIC_PROVIDER_SUCCESS",
  CLOUD_CONNECT_PROVIDER: "CLOUD_CONNECT_PROVIDER",
  CLOUD_CONNECT_PROVIDER_SUCCESS: "CLOUD_CONNECT_PROVIDER_SUCCESS",
  CLOUD_CONNECT_PROVIDER_ERROR: "CLOUD_CONNECT_PROVIDER_ERROR",
  SET_CLOUD_CONNECT_LOADING: "SET_CLOUD_CONNECT_LOADING",

  GET_ACCOUNT_DETAILS_ACTION: "GET_ACCOUNT_DETAILS_ACTION",
  GET_ACCOUNT_DETAILS_SUCCESS: "GET_ACCOUNT_DETAILS_SUCCESS",
  GET_ACCOUNT_DETAILS_ERROR: "GET_ACCOUNT_DETAILS_ERROR",
  GET_ACCOUNT_DETAILS_RESET: "GET_ACCOUNT_DETAILS_RESET",

  GET_CLEANING_JOBS_ACTION: "GET_CLEANING_JOBS_ACTION",
  GET_CLEANING_JOBS_SUCCESS: "GET_CLEANING_JOBS_SUCCESS",
  GET_CLEANING_JOBS_ERROR: "GET_CLEANING_JOBS_ERROR",
  GET_CLEANING_JOBS_RESET: "GET_CLEANING_JOBS_RESET",

  GET_AWS_USAGE_ACTION: "GET_AWS_USAGE_ACTION",
  GET_AWS_USAGE_SUCCESS: "GET_AWS_USAGE_SUCCESS",
  GET_AWS_USAGE_ERROR: "GET_AWS_USAGE_ERROR",
  GET_AWS_USAGE_RESET: "GET_AWS_USAGE_RESET",

  MAINTENANCE_SESSION_ACTION: "MAINTENANCE_SESSION_ACTION",
  MAINTENANCE_SESSION_SUCCESS: "MAINTENANCE_SESSION_SUCCESS",
  MAINTENANCE_SESSION_ERROR: "MAINTENANCE_SESSION_ERROR",
  MAINTENANCE_SESSION_RESET: "MAINTENANCE_SESSION_RESET",

  MARK_AS_CLEAN_ACTION: "MARK_AS_CLEAN_ACTION",
  MARK_AS_CLEAN_SUCCESS: "MARK_AS_CLEAN_SUCCESS",
  MARK_AS_CLEAN_ERROR: "MARK_AS_CLEAN_ERROR",
  MARK_AS_CLEAN_RESET: "MARK_AS_CLEAN_RESET",
};

export const machineCatalogActions = {
  FETCH_CATALOG_LIST_DATA: "FETCH_CATALOG_LIST_DATA",
  SET_CATALOG_LIST_DATA: "SET_CATALOG_LIST_DATA",
  SET_CATALOG_LIST_ERROR: "SET_CATALOG_LIST_ERROR",
  DELETE_CATALOG: "DELETE_CATALOG",
  DELETE_CATALOG_SUCCESS: "DELETE_CATALOG_SUCCESS",
  DELETE_CATALOG_ERROR: "DELETE_CATALOG_ERROR",
  CHANGE_CATALOG_STATUS: "CHANGE_CATALOG_STATUS",
  CHANGE_CATALOG_STATUS_LOADING: "CHANGE_CATALOG_STATUS_LOADING",
  CHANGE_CATALOG_STATUS_SUCCESS: "CHANGE_CATALOG_STATUS_SUCCESS",
  CHANGE_CATALOG_STATUS_ERROR: "CHANGE_CATALOG_STATUS_ERROR",
  CLONE_REQUEST: "CLONE_REQUEST",
  CLONE_SUCCESS: "CLONE_SUCCESS",
  CLONE_ERROR: "CLONE_ERROR",
  SET_CLONE_REQUEST: "SET_CLONE_REQUEST",
  SET_CLONE_SUCCESS: "SET_CLONE_SUCCESS",
  SET_CLONE_ERROR: "SET_CLONE_ERROR",
  RESET_CLONE_ERROR: "RESET_CLONE_ERROR",
  RESET_DELETE_ERROR: "RESET_DELETE_ERROR",
  RESET_CATALOG_LIST: "RESET_CATALOG_LIST",
  SET_ACTION_DATA: "SET_ACTION_DATA",
  REQUEST_CREATE_CATALOG_PLAN_MAP: "REQUEST_CREATE_CATALOG_PLAN_MAP",
  SUCCESS_CREATE_CATALOG_PLAN_MAP: "SUCCESS_CREATE_CATALOG_PLAN_MAP",
  ERROR_CREATE_CATALOG_PLAN_MAP: "ERROR_CREATE_CATALOG_PLAN_MAP",
  REQUEST_UPDATE_CATALOG_PLAN_MAP: "REQUEST_UPDATE_CATALOG_PLAN_MAP",
  SUCCESS_UPDATE_CATALOG_PLAN_MAP: "SUCCESS_UPDATE_CATALOG_PLAN_MAP",
  ERROR_UPDATE_CATALOG_PLAN_MAP: "ERROR_UPDATE_CATALOG_PLAN_MAP",
  REQUEST_RETRIVE_CATALOG_PLAN_MAP: "REQUEST_RETRIVE_CATALOG_PLAN_MAP",
  SUCCESS_RETRIVE_CATALOG_PLAN_MAP: "SUCCESS_RETRIVE_CATALOG_PLAN_MAP",
  ERROR_RETRIVE_CATALOG_PLAN_MAP: "ERROR_RETRIVE_CATALOG_PLAN_MAP",
  REQUEST_MARKED_CATALOG_B2C: "REQUEST_MARKED_CATALOG_B2C",
  SUCCESS_MARKED_CATALOG_B2C: "SUCCESS_MARKED_CATALOG_B2C",
  ERROR_MARKED_CATALOG_B2C: "ERROR_MARKED_CATALOG_B2C",

  FETCH_CLOUD_TEMPLATES: "FETCH_CLOUD_TEMPLATES",
  FETCH_CLOUD_TEMPLATES_SUCCESS: "FETCH_CLOUD_TEMPLATES_SUCCESS",
  FETCH_CLOUD_TEMPLATES_ERROR: "FETCH_CLOUD_TEMPLATES_ERROR",

  FETCH_CLOUD_TEMPLATE_BY_ID: "FETCH_CLOUD_TEMPLATE_BY_ID",
  FETCH_CLOUD_TEMPLATE_BY_ID_SUCCESS: "FETCH_CLOUD_TEMPLATE_BY_ID_SUCCESS",
  FETCH_CLOUD_TEMPLATE_BY_ID_ERROR: "FETCH_CLOUD_TEMPLATE_BY_ID_ERROR",

  CREATE_CLOUD_BATCH: "CREATE_CLOUD_BATCH",
  CREATE_CLOUD_BATCH_SUCCESS: "CREATE_CLOUD_BATCH_SUCCESS",
  CREATE_CLOUD_BATCH_ERROR: "CREATE_CLOUD_BATCH_ERROR",

  DELETE_CLOUD_BATCH: "DELETE_CLOUD_BATCH",
  DELETE_CLOUD_BATCH_SUCCESS: "DELETE_CLOUD_BATCH_SUCCESS",
  DELETE_CLOUD_BATCH_ERROR: "DELETE_CLOUD_BATCH_ERROR",

  FETCH_CLOUD_BATCH_BY_ID: "FETCH_CLOUD_BATCH_BY_ID",
  FETCH_CLOUD_BATCH_BY_ID_SUCCESS: "FETCH_CLOUD_BATCH_BY_ID_SUCCESS",
  FETCH_CLOUD_BATCH_BY_ID_ERROR: "FETCH_CLOUD_BATCH_BY_ID_ERROR",

  LIST_CLOUD_BATCH_: "LIST_CLOUD_BATCH",
  LIST_CLOUD_BATCH_SUCCESS: "LIST_CLOUD_BATCH_SUCCESS",
  LIST_CLOUD_BATCH_ERROR: "LIST_CLOUD_BATCH_ERROR",

  CREATE_CLOUD_LAB: "CREATE_CLOUD_LAB",
  CREATE_CLOUD_LAB_SUCCESS: "CREATE_CLOUD_LAB_SUCCESS",
  CREATE_CLOUD_LAB_ERROR: "CREATE_CLOUD_LAB_ERROR",

  DELETE_CLOUD_LAB: "DELETE_CLOUD_LAB",
  DELETE_CLOUD_LAB_SUCCESS: "DELETE_CLOUD_LAB_SUCCESS",
  DELETE_CLOUD_LAB_ERROR: "DELETE_CLOUD_LAB_ERROR",

  LIST_CLOUD_LAB_: "LIST_CLOUD_LAB",
  LIST_CLOUD_LAB_SUCCESS: "LIST_CLOUD_LAB_SUCCESS",
  LIST_CLOUD_LAB_ERROR: "LIST_CLOUD_LAB_ERROR",

  FETCH_CLOUD_LAB_BY_ID: "FETCH_CLOUD_LAB_BY_ID",
  FETCH_CLOUD_LAB_BY_ID_SUCCESS: "FETCH_CLOUD_LAB_BY_ID_SUCCESS",
  FETCH_CLOUD_LAB_BY_ID_ERROR: "FETCH_CLOUD_LAB_BY_ID_ERROR",

  CREATE_CLOUD_LAB_FEEDBACK: "CREATE_CLOUD_LAB_FEEDBACK",
  CREATE_CLOUD_LAB_FEEDBACK_SUCCESS: "CREATE_CLOUD_LAB_FEEDBACK_SUCCESS",
  CREATE_CLOUD_LAB_FEEDBACK_ERROR: "CREATE_CLOUD_LAB_FEEDBACK_ERROR",

  PATCH_CLOUD_LAB_FEEDBACK: "PATCH_CLOUD_LAB_FEEDBACK",
  PATCH_CLOUD_LAB_FEEDBACK_SUCCESS: "PATCH_CLOUD_LAB_FEEDBACK_SUCCESS",
  PATCH_CLOUD_LAB_FEEDBACK_ERROR: "PATCH_CLOUD_LAB_FEEDBACK_ERROR",

  DELETE_CLOUD_LAB_FEEDBACK: "DELETE_CLOUD_LAB_FEEDBACK",
  DELETE_CLOUD_LAB_FEEDBACK_SUCCESS: "DELETE_CLOUD_LAB_FEEDBACK_SUCCESS",
  DELETE_CLOUD_LAB_FEEDBACK_ERROR: "DELETE_CLOUD_LAB_FEEDBACK_ERROR",

  LIST_CLOUD_LAB_FEEDBACK: "LIST_CLOUD_LAB_FEEDBACK",
  LIST_CLOUD_LAB_FEEDBACK_SUCCESS: "LIST_CLOUD_LAB_FEEDBACK_SUCCESS",
  LIST_CLOUD_LAB_FEEDBACK_ERROR: "LIST_CLOUD_LAB_FEEDBACK_ERROR",

  FETCH_CLOUD_LAB_FEEDBACK_BY_ID: "FETCH_CLOUD_LAB_FEEDBACK_BY_ID",
  FETCH_CLOUD_LAB_FEEDBACK_BY_ID_SUCCESS:
    "FETCH_CLOUD_LAB_FEEDBACK_BY_ID_SUCCESS",
  FETCH_CLOUD_LAB_FEEDBACK_BY_ID_ERROR: "FETCH_CLOUD_LAB_FEEDBACK_BY_ID_ERROR",

  REQUEST_EXPORT_CATALOG: "REQUEST_EXPORT_CATALOG",
  SUCCESS_EXPORT_CATALOG: "SUCCESS_EXPORT_CATALOG",
  ERROR_EXPORT_CATALOG: "ERROR_EXPORT_CATALOG",

  SET_PUBLIC_CLOUD_ACTION: "SET_PUBLIC_CLOUD_ACTION",
};

export const machineCatalogueActions = {
  SELECTED_TAB: "SELECTED_TAB",
  SKUSLISTGETDATA: "SKUSLIST_FETCH_DATA",
  SKUSLISTSETDATA: "SKUSLIST_SET_DATA",
  SKUSLISTSETERROR: "SKUSLIST_SET_ERROR",
  CREATE_CATALOG_REQUEST: "CREATE_CATALOG_REQUEST",
  CATALOG_CREATE_SUCCESS: "CATALOG_CREATE_SUCCESS",
  CATALOG_CREATE_ERROR: "CATALOG_CREATE_ERROR",
  EDIT_CATALOG_REQUEST: "EDIT_CATALOG_REQUEST",
  EDIT_CATALOG_SUCCESS: "EDIT_CATALOG_SUCCESS",
  EDIT_CATALOG_ERROR: "EDIT_CATALOG_ERROR",
  CATALOG_BULK_UPLOAD_REQUEST: "CATALOG_BULK_UPLOAD_REQUEST",
  CATALOG_BULK_UPLOAD_SUCCESS: "CATALOG_BULK_UPLOAD_SUCCESS",
  CATALOG_BULK_UPLOAD_ERROR: "CATALOG_BULK_UPLOAD_ERROR",
  REMOVE_SKU_REQUEST: "REMOVE_SKU_REQUEST",
  REMOVE_SKU_SUCCESS: "REMOVE_SKU_SUCCESS",
  REMOVE_SKU_ERROR: "REMOVE_SKU_ERROR",
  ADD_SKU_REQUEST: "ADD_SKU_REQUEST",
  ADD_SKU_SUCCESS: "ADD_SKU_SUCCESS",
  ADD_SKU_ERROR: "ADD_SKU_ERROR",
  RETIRE_SKU_REQUEST: "RETIRE_SKU_REQUEST",
  RETIRE_SKU_SUCCESS: "RETIRE_SKU_SUCCESS",
  RETIRE_SKU_ERROR: "RETIRE_SKU_ERROR",
  FETCH_CLOUD_TEMPLATES: "FETCH_CLOUD_TEMPLATES",
  FETCH_CLOUD_TEMPLATES_SUCCESS: "FETCH_CLOUD_TEMPLATES_SUCCESS",
  FETCH_CLOUD_TEMPLATES_ERROR: "FETCH_CLOUD_TEMPLATES_ERROR",
  DELETE_CLOUD_TEMPLATE: "DELETE_CLOUD_TEMPLATE",
  DELETE_CLOUD_TEMPLATE_SUCCESS: "DELETE_CLOUD_TEMPLATE_SUCCESS",
  DELETE_CLOUD_TEMPLATE_ERROR: "DELETE_CLOUD_TEMPLATE_ERROR",
  FETCH_CLOUD_TEMPLATE_BY_ID: "FETCH_CLOUD_TEMPLATE_BY_ID",
  FETCH_CLOUD_TEMPLATE_BY_ID_SUCCESS: "FETCH_CLOUD_TEMPLATE_BY_ID_SUCCESS",
  FETCH_CLOUD_TEMPLATE_BY_ID_ERROR: "FETCH_CLOUD_TEMPLATE_BY_ID_ERROR",
  CREATE_CLOUD_BATCH: "CREATE_CLOUD_BATCH",
  CREATE_CLOUD_BATCH_SUCCESS: "CREATE_CLOUD_BATCH_SUCCESS",
  CREATE_CLOUD_BATCH_ERROR: "CREATE_CLOUD_BATCH_ERROR",
  EDIT_CLOUD_BATCH: "EDIT_CLOUD_BATCH",
  PATCH_CLOUD_BATCH: "PATCH_CLOUD_BATCH",
  DELETE_CLOUD_BATCH: "DELETE_CLOUD_BATCH",
  DELETE_CLOUD_BATCH_SUCCESS: "DELETE_CLOUD_BATCH_SUCCESS",
  DELETE_CLOUD_BATCH_ERROR: "DELETE_CLOUD_BATCH_ERROR",
  FETCH_CLOUD_BATCH_BY_ID: "FETCH_CLOUD_BATCH_BY_ID",
  FETCH_CLOUD_BATCH_BY_ID_SUCCESS: "FETCH_CLOUD_BATCH_BY_ID_SUCCESS",
  FETCH_CLOUD_BATCH_BY_ID_ERROR: "FETCH_CLOUD_BATCH_BY_ID_ERROR",
  FETCH_WORKSPACE_CLOUD_BATCH_BY_ID: "FETCH_CLOUD_BATCH_BY_ID",
  FETCH_WORKSPACE_CLOUD_BATCH_BY_ID_SUCCESS: "FETCH_CLOUD_BATCH_BY_ID_SUCCESS",
  FETCH_WORKSPACE_CLOUD_BATCH_BY_ID_ERROR: "FETCH_CLOUD_BATCH_BY_ID_ERROR",
  LIST_CLOUD_BATCH: "LIST_CLOUD_BATCH",
  LIST_CLOUD_BATCH_SUCCESS: "LIST_CLOUD_BATCH_SUCCESS",
  LIST_CLOUD_BATCH_ERROR: "LIST_CLOUD_BATCH_ERROR",
  LIST_WORKSPACE_CLOUD_BATCH: "LIST_WORKSPACE_CLOUD_BATCH",
  LIST_WORKSPACE_CLOUD_BATCH_SUCCESS: "LIST_WORKSPACE_CLOUD_BATCH_SUCCESS",
  LIST_WORKSPACE_CLOUD_BATCH_ERROR: "LIST_WORKSPACE_CLOUD_BATCH_ERROR",
  RESET_CLOUD_BATCH_LIST: "RESET_CLOUD_BATCH_LIST",
  CREATE_CLOUD_LAB: "CREATE_CLOUD_LAB",
  CREATE_CLOUD_LAB_SUCCESS: "CREATE_CLOUD_LAB_SUCCESS",
  CREATE_CLOUD_LAB_ERROR: "CREATE_CLOUD_LAB_ERROR",
  DELETE_CLOUD_LAB: "DELETE_CLOUD_LAB",
  DELETE_CLOUD_LAB_SUCCESS: "DELETE_CLOUD_LAB_SUCCESS",
  DELETE_CLOUD_LAB_ERROR: "DELETE_CLOUD_LAB_ERROR",
  LIST_CLOUD_LAB: "LIST_CLOUD_LAB",
  LIST_CLOUD_LAB_SUCCESS: "LIST_CLOUD_LAB_SUCCESS",
  LIST_CLOUD_LAB_ERROR: "LIST_CLOUD_LAB_ERROR",
  FETCH_CLOUD_LAB_BY_ID: "FETCH_CLOUD_LAB_BY_ID",
  FETCH_CLOUD_LAB_BY_ID_SUCCESS: "FETCH_CLOUD_LAB_BY_ID_SUCCESS",
  FETCH_CLOUD_LAB_BY_ID_ERROR: "FETCH_CLOUD_LAB_BY_ID_ERROR",
  CREATE_CLOUD_LAB_EXTENISION: "CREATE_CLOUD_LAB_EXTENISION",
  CREATE_CLOUD_LAB_EXTENISION_SUCCESS: "CREATE_CLOUD_LAB_EXTENISION_SUCCESS",
  CREATE_CLOUD_LAB_EXTENISION_ERROR: "CREATE_CLOUD_LAB_EXTENISION_ERROR",
  CREATE_CLOUD_BATCH_EXTENISION: "CREATE_CLOUD_BATCH_EXTENISION",
  PATCH_CLOUD_LAB_FEEDBACK: "PATCH_CLOUD_LAB_FEEDBACK",
  PATCH_CLOUD_LAB_FEEDBACK_SUCCESS: "PATCH_CLOUD_LAB_FEEDBACK_SUCCESS",
  PATCH_CLOUD_LAB_FEEDBACK_ERROR: "PATCH_CLOUD_LAB_FEEDBACK_ERROR",
  DELETE_CLOUD_LAB_FEEDBACK: "DELETE_CLOUD_LAB_FEEDBACK",
  DELETE_CLOUD_LAB_FEEDBACK_SUCCESS: "DELETE_CLOUD_LAB_FEEDBACK_SUCCESS",
  DELETE_CLOUD_LAB_FEEDBACK_ERROR: "DELETE_CLOUD_LAB_FEEDBACK_ERROR",
  LIST_CLOUD_LAB_FEEDBACK: "LIST_CLOUD_LAB_FEEDBACK",
  LIST_CLOUD_LAB_FEEDBACK_SUCCESS: "LIST_CLOUD_LAB_FEEDBACK_SUCCESS",
  LIST_CLOUD_LAB_FEEDBACK_ERROR: "LIST_CLOUD_LAB_FEEDBACK_ERROR",
  FETCH_CLOUD_LAB_FEEDBACK_BY_ID: "FETCH_CLOUD_LAB_FEEDBACK_BY_ID",
  FETCH_CLOUD_LAB_FEEDBACK_BY_ID_SUCCESS:
    "FETCH_CLOUD_LAB_FEEDBACK_BY_ID_SUCCESS",
  FETCH_CLOUD_LAB_FEEDBACK_BY_ID_ERROR: "FETCH_CLOUD_LAB_FEEDBACK_BY_ID_ERROR",
  SET_BATCH_LOADING: "SET_BATCH_LOADING",
  SET_LAB_LOADING: "SET_LAB_LOADING",
  SET_LAB_DETAILS_LOADING: "SET_LAB_DETAILS_LOADING",
  SET_TEMPLATE_DETAILS_LOADING: "SET_TEMPLATE_DETAILS_LOADING",
  SET_BATCH_DETAILS_LOADING: "SET_BATCH_DETAILS_LOADING",
  SET_LINK_TENANT_LIST_LOADING: "SET_LINK_TENANT_LIST_LOADING",
  SET_LINK_TENANT_LOADING: "SET_LINK_TENANT_LOADING",
  SET_DELETE_LINK_TENANT_LOADING: "SET_DELETE_LINK_TENANT_LOADING",
  CREATE_LINK_TENANT: "CREATE_LINK_TENANT",
  CREATE_LINK_TENANT_SUCCESS: "CREATE_LINK_TENANT_SUCCESS",
  CREATE_LINK_TENANT_ERROR: "CREATE_LINK_TENANT_ERROR",
  EDIT_LINK_TENANT: "EDIT_LINK_TENANT",
  EDIT_LINK_TENANT_SUCCESS: "EDIT_LINK_TENANT_SUCCESS",
  EDIT_LINK_TENANT_ERROR: "EDIT_LINK_TENANT_ERROR",
  RETRIEVE_BY_ID_LINK_TENANT: "RETRIEVE_BY_ID_LINK_TENANT",
  RETRIEVE_BY_ID_LINK_TENANT_SUCCESS: "RETRIEVE_BY_ID_LINK_TENANT_SUCCESS",
  RETRIEVE_BY_ID_LINK_TENANT_ERROR: "RETRIEVE_BY_ID_LINK_TENANT_ERROR",
  LIST_LINK_TENANT: "LIST_LINK_TENANT",
  LIST_LINK_TENANT_SUCCESS: "LIST_LINK_TENANT_SUCCESS",
  LIST_LINK_TENANT_ERROR: "LIST_LINK_TENANT_ERROR",
  DELETE_LINK_TENANT: "DELETE_LINK_TENANT",
  DELETE_LINK_TENANT_SUCCESS: "DELETE_LINK_TENANT_SUCCESS",
  DELETE_LINK_TENANT_ERROR: "DELETE_LINK_TENANT_ERROR",
  REQUEST_CLOUD_LAB_CREDENTIAL: "REQUEST_CLOUD_LAB_CREDENTIAL",
  SUCCESS_CLOUD_LAB_CREDENTIAL: "SUCCESS_CLOUD_LAB_CREDENTIAL",
  ERROR_CLOUD_LAB_CREDENTIAL: "ERROR_CLOUD_LAB_CREDENTIAL",
  SET_CLOUD_CREDENTIALS: "SET_CLOUD_CREDENTIALS",
  UPDATE_PERMISSION_POLICY: "UPDATE_PERMISSION_POLICY",
  GET_MENTOR_LIST: "GET_MENTOR_LIST",
  GET_MENTOR_LIST_SUCCESS: "GET_MENTOR_LIST_SUCCESS",
  GET_MENTOR_LIST_ERROR: "GET_MENTOR_LIST_ERROR",
  RESET_MENTOR_LIST: "RESET_MENTOR_LIST",
  UPDATE_PERMISSION_POLICY_SUCCESS: "UPDATE_PERMISSION_POLICY_SUCCESS",
  UPDATE_PERMISSION_POLICY_ERROR: "UPDATE_PERMISSION_POLICY_ERROR",
  CLOUD_LAB_RE_PROVISION: "CLOUD_LAB_RE_PROVISION",
  CLOUD_LAB_RE_PROVISION_SUCCESS: "CLOUD_LAB_RE_PROVISION_SUCCESS",
  CLOUD_LAB_RE_PROVISION_ERROR: "CLOUD_LAB_RE_PROVISION_ERROR",
  GET_WORKSPACE_BATCH_REPORTS_LIST: "GET_WORKSPACE_BATCH_REPORTS_LIST",
  SET_WORKSPACE_BATCH_REPORTS_LIST_SUCCESS:
    "SET_WORKSPACE_BATCH_REPORTS_LIST_SUCCESS",
  SET_WORKSPACE_BATCH_REPORTS_LIST_ERROR:
    "SET_WORKSPACE_BATCH_REPORTS_LIST_ERROR",
  RESET_WORKSPACE_BATCH_REPORTS_LIST: "RESET_WORKSPACE_BATCH_REPORTS_LIST",
  GET_WORKSPACE_TENANT_LIST: "GET_WORKSPACE_TENANT_LIST",
  SET_WORKSPACE_TENANT_LIST_SUCCESS: "SET_WORKSPACE_TENANT_LIST_SUCCESS",
  GET_WORKSPACES_LIST: "GET_WORKSPACES_LIST",
  SET_WORKSPACES_LIST_SUCCESS: "SET_WORKSPACES_LIST_SUCCESS",
  GENERATE_WORKSPACE_BATCH_REPORT: "GENERATE_WORKSPACE_BATCH_REPORT",
  GENERATE_WORKSPACE_BATCH_REPORT_SUCCESS:
    "GENERATE_WORKSPACE_BATCH_REPORT_SUCCESS",
  GENERATE_WORKSPACE_BATCH_REPORT_ERROR:
    "GENERATE_WORKSPACE_BATCH_REPORT_ERROR",
  RESET_WORKSPACE_BATCH_REPORTS_FORM: "RESET_WORKSPACE_BATCH_REPORTS_FORM",
  WORKSPACE_BATCH_REPORTS_LOADER: "WORKSPACE_BATCH_REPORTS_LOADER",

  // Azure Report Download
  AZURE_REPORT_DOWNLOAD_LOADING: "AZURE_REPORT_DOWNLOAD_LOADING",
  AZURE_REPORT_DOWNLOAD_ACTION: "AZURE_REPORT_DOWNLOAD_ACTION",
  AZURE_REPORT_DOWNLOAD_SUCCESS: "AZURE_REPORT_DOWNLOAD_SUCCESS",
  AZURE_REPORT_DOWNLOAD_ERROR: "AZURE_REPORT_DOWNLOAD_ERROR",
  AZURE_REPORT_DOWNLOAD_RESET: "AZURE_REPORT_DOWNLOAD_RESET",

  // Clean Up Azure
  CLEAN_UP_AZURE_LOADING: "CLEAN_UP_AZURE_LOADING",
  CLEAN_UP_AZURE_ACTION: "CLEAN_UP_AZURE_ACTION",
  CLEAN_UP_AZURE_SUCCESS: "CLEAN_UP_AZURE_SUCCESS",
  CLEAN_UP_AZURE_ERROR: "CLEAN_UP_AZURE_ERROR",
  CLEAN_UP_AZURE_RESET: "CLEAN_UP_AZURE_RESET",
  SYNC_BILL_ACTION: "SYNC_BILL_ACTION",
  SYNC_BILL_SUCCESS: "SYNC_BILL_SUCCESS",
  SYNC_BILL_ERROR: "SYNC_BILL_ERROR",

  // Clean up aws
  AWS_CLEANUP_LOADING: "AWS_CLEANUP_LOADING",
  AWS_CLEANUP_ACTION: "AWS_CLEANUP_ACTION",
  AWS_CLEANUP_SUCCESS: "AWS_CLEANUP_SUCCESS",
  AWS_CLEANUP_ERROR: "AWS_CLEANUP_ERROR",
  AWS_CLEANUP_RESET: "AWS_CLEANUP_RESET",
};

export const myLabs = {
  MY_LABS_LIST_REQUEST: "MY_LABS_LIST_REQUEST",
  MY_LABS_LIST_SUCCESS: "MY_LABS_LIST_SUCCESS",
  MY_LABS_LIST_ERROR: "MY_LABS_LIST_ERROR",
  CLEAR_MY_LABS_LIST: "CLEAR_MY_LABS_LIST",
  MY_LAB_VM_OPERATION: "MY_LAB_VM_OPERATION",
  START_MY_LAB_SUCCESS: "START_MY_LAB_SUCCESS",
  STOP_MY_LAB_SUCCESS: "STOP_MY_LAB_SUCCESS",
  SUSPEND_MY_LAB_SUCCESS: "SUSPEND_MY_LAB_SUCCESS",
  RESET_MY_LAB_SUCCESS: "RESET_MY_LAB_SUCCESS",
  SHUTDOWN_MY_LAB_SUCCESS: "SHUTDOWN_MY_LAB_SUCCESS",
  RESTART_MY_LAB_SUCCESS: "RESTART_MY_LAB_SUCCESS",
  DELETE_MY_LAB_SUCCESS: "DELETE_MY_LAB_SUCCESS",
  FORCE_DELETE_MY_LAB_SUCCESS: "FORCE_DELETE_MY_LAB_SUCCESS",
  LOADER_GET_REQUEST: "LOADER_GET_REQUEST",
  LOADER_GET_SUCCESS: "LOADER_GET_SUCCESS",
  LOADER_B2C_GET_REQUEST: "LOADER_B2C_GET_REQUEST",
  LOADER_B2C_GET_SUCCESS: "LOADER_B2C_GET_SUCCESS",
  REQUEST_UPDATE_RATE: "REQUEST_UPDATE_RATE",
  SUCCESS_UPDATE_RATE: "SUCCESS_UPDATE_RATE",
  ERROR_UPDATE_RATE: "ERROR_UPDATE_RATE",
  CONNECT_GET_ERROR: "CONNECT_GET_ERROR",
  CONNECT_GET_SUCCESS: "CONNECT_GET_SUCCESS",
  CONNECT_GET_REQUEST: "CONNECT_GET_REQUEST",
  EXTENSION_VALIDITY_GET_ERROR: "EXTENSION_VALIDITY_GET_ERROR",
  EXTENSION_VALIDITY_GET_SUCCESS: "EXTENSION_VALIDITY_GET_SUCCESS",
  EXTENSION_VALIDITY_GET_REQUEST: "EXTENSION_VALIDITY_GET_REQUEST",
  EXTENSION_VALIDITY_UPDATE_ERROR: "EXTENSION_VALIDITY_UPDATE_ERROR",
  EXTENSION_VALIDITY_UPDATE_SUCCESS: "EXTENSION_VALIDITY_UPDATE_SUCCESS",
  EXTENSION_VALIDITY_UPDATE_REQUEST: "EXTENSION_VALIDITY_UPDATE_REQUEST",
  EXTENSION_VALIDITY_UPDATE_REQUEST_WORKSPACE:
    "EXTENSION_VALIDITY_UPDATE_REQUEST_WORKSPACE",
  EXTENSION_VALIDITY_CREATE_REQUEST_WORKSPACE:
    "EXTENSION_VALIDITY_CREATE_REQUEST_WORKSPACE",
  EXTENSION_VALIDITY_CREATE_REQUEST: "EXTENSION_VALIDITY_CREATE_REQUEST",
  SET_WEB_SOCKET_DATA: "SET_WEB_SOCKET_DATA",
  VM_AUTH_CONNECT_SUCCESS: "VM_AUTH_CONNECT_SUCCESS",
  VM_AUTH_CONNECT_REQUEST: "VM_AUTH_CONNECT_REQUEST",
  VM_AUTH_CONNECT_DETAILS: "VM_AUTH_CONNECT_DETAILS",
  REQUEST_VM_DETAILS: "REQUEST_VM_DETAILS",
  SUCCESS_VM_DETAILS: "SUCCESS_VM_DETAILS",
  ERROR_VM_DETAILS: "ERROR_VM_DETAILS",
  REMOVE_SELECTED_VM_DETAILS: "REMOVE_SELECTED_VM_DETAILS",
  GET_POOLED_VM_TIMER: "GET_POOLED_VM_TIMER",
  POOLED_VM_TIMER_SUCCESS: "POOLED_VM_TIMER_SUCCESS",
  POOLED_VM_TIMER_ERROR: "POOLED_VM_TIMER_ERROR",
  ADD_VM_DURATION: "ADD_VM_DURATION",
  ADD_VM_DURATION_API_RESPONSE: "ADD_VM_DURATION_API_RESPONSE",
  ADD_VM_DURATION_LOADER: "ADD_VM_DURATION_LOADER",
  GET_LAB_INSTRUCTIONS: "GET_LAB_INSTRUCTIONS",
  SET_LAB_INSTRUCTIONS: "SET_LAB_INSTRUCTIONS",
  GET_INSTANCE_SIZE_LIST: "GET_INSTANCE_SIZE_LIST",
  SET_INSTANCE_SIZE_LIST: "SET_INSTANCE_SIZE_LIST",
  INSTANCE_SIZE_LIST_LOADER: "INSTANCE_SIZE_LIST_LOADER",
  RE_CONFIGURE_VM_LOADER: "RE_CONFIGURE_VM_LOADER",
  RE_CONFIGURE_VM: "RE_CONFIGURE_VM",
  RE_CONFIGURE_VM_SUCCESS: "RE_CONFIGURE_VM_SUCCESS",
  RE_CONFIGURE_VM_ERROR: "RE_CONFIGURE_VM_ERROR",

  RE_PROVISION_LAB_ACTION: "RE_PROVISION_LAB_ACTION",
  RE_PROVISION_LAB_SUCCESS: "RE_PROVISION_LAB_SUCCESS",
  RE_PROVISION_LAB_ERROR: "RE_PROVISION_LAB_ERROR",
  RE_PROVISION_LAB_RESET: "RE_PROVISION_LAB_RESET",

  VM_STATE_MANAGEMENT_LOADING: "VM_STATE_MANAGEMENT_LOADING",
  VM_STATE_MANAGEMENT_ACTION: "VM_STATE_MANAGEMENT_ACTION",
  VM_STATE_MANAGEMENT_SUCCESS: "VM_STATE_MANAGEMENT_SUCCESS",
  VM_STATE_MANAGEMENT_ERROR: "VM_STATE_MANAGEMENT_ERROR",
  VM_STATE_MANAGEMENT_RESET: "VM_STATE_MANAGEMENT_RESET",

  MANAGE_VM_DOWNLOAD_LOADING: "MANAGE_VM_DOWNLOAD_LOADING",
  MANAGE_VM_DOWNLOAD_ACTION: "MANAGE_VM_DOWNLOAD_ACTION",
  MANAGE_VM_DOWNLOAD_SUCCESS: "MANAGE_VM_DOWNLOAD_SUCCESS",
  MANAGE_VM_DOWNLOAD_ERROR: "MANAGE_VM_DOWNLOAD_ERROR",
  MANAGE_VM_DOWNLOAD_RESET: "MANAGE_VM_DOWNLOAD_RESET",

  RESTORE_VM_LOADING: "RESTORE_VM_LOADING",
  RESTORE_VM_ACTION: "RESTORE_VM_ACTION",
  RESTORE_VM_SUCCESS: "RESTORE_VM_SUCCESS",
  RESTORE_VM_ERROR: "RESTORE_VM_ERROR",
  RESTORE_VM_RESET: "RESTORE_VM_RESET",
};

export const publicResourceProvider = {
  CLOUD_VM_LOADING: "CLOUD_VM_LOADING",

  GET_CLOUD_VM_LIST_ACTION: "GET_CLOUD_VM_LIST_ACTION",
  GET_CLOUD_VM_LIST_SUCCESS: "GET_CLOUD_VM_LIST_SUCCESS",
  GET_CLOUD_VM_LIST_ERROR: "GET_CLOUD_VM_LIST_ERROR",
  GET_CLOUD_VM_LIST_RESET: "GET_CLOUD_VM_LIST_RESET",

  CLOUD_VM_OPERATION_ACTION: "CLOUD_VM_OPERATION_ACTION",
  CLOUD_VM_OPERATION_SUCCESS: "CLOUD_VM_OPERATION_SUCCESS",
  CLOUD_VM_OPERATION_ERROR: "CLOUD_VM_OPERATION_ERROR",
  CLOUD_VM_OPERATION_RESET: "CLOUD_VM_OPERATION_RESET",

  CLOUD_PROVIDER_AZURE_LIST_ACTION: "CLOUD_PROVIDER_AZURE_LIST_ACTION",
  CLOUD_PROVIDER_AZURE_LIST_SUCCESS: "CLOUD_PROVIDER_AZURE_LIST_SUCCESS",
  CLOUD_PROVIDER_AZURE_LIST_ERROR: "CLOUD_PROVIDER_AZURE_LIST_ERROR",
  CLOUD_PROVIDER_AZURE_LIST_RESET: "CLOUD_PROVIDER_AZURE_LIST_RESET",

  // Cascading dropdowns for Azure VM Form
  FETCH_RESOURCE_GROUPS_ACTION: "FETCH_RESOURCE_GROUPS_ACTION",
  FETCH_RESOURCE_GROUPS_SUCCESS: "FETCH_RESOURCE_GROUPS_SUCCESS",
  FETCH_RESOURCE_GROUPS_ERROR: "FETCH_RESOURCE_GROUPS_ERROR",
  FETCH_RESOURCE_GROUPS_RESET: "FETCH_RESOURCE_GROUPS_RESET",

  FETCH_COMPUTE_GALLERY_ACTION: "FETCH_COMPUTE_GALLERY_ACTION",
  FETCH_COMPUTE_GALLERY_SUCCESS: "FETCH_COMPUTE_GALLERY_SUCCESS",
  FETCH_COMPUTE_GALLERY_ERROR: "FETCH_COMPUTE_GALLERY_ERROR",
  FETCH_COMPUTE_GALLERY_RESET: "FETCH_COMPUTE_GALLERY_RESET",

  FETCH_GALLERY_IMAGE_ACTION: "FETCH_GALLERY_IMAGE_ACTION",
  FETCH_GALLERY_IMAGE_SUCCESS: "FETCH_GALLERY_IMAGE_SUCCESS",
  FETCH_GALLERY_IMAGE_ERROR: "FETCH_GALLERY_IMAGE_ERROR",
  FETCH_GALLERY_IMAGE_RESET: "FETCH_GALLERY_IMAGE_RESET",



  FETCH_INSTANCE_SIZE_ACTION: "FETCH_INSTANCE_SIZE_ACTION",
  FETCH_INSTANCE_SIZE_SUCCESS: "FETCH_INSTANCE_SIZE_SUCCESS",
  FETCH_INSTANCE_SIZE_ERROR: "FETCH_INSTANCE_SIZE_ERROR",
  FETCH_INSTANCE_SIZE_RESET: "FETCH_INSTANCE_SIZE_RESET",

  CREATE_AZURE_VM_TEMPLATE_ACTION: "CREATE_AZURE_VM_TEMPLATE_ACTION",
  CREATE_AZURE_VM_TEMPLATE_SUCCESS: "CREATE_AZURE_VM_TEMPLATE_SUCCESS",
  CREATE_AZURE_VM_TEMPLATE_ERROR: "CREATE_AZURE_VM_TEMPLATE_ERROR",
  CREATE_AZURE_VM_TEMPLATE_RESET: "CREATE_AZURE_VM_TEMPLATE_RESET",

  UPDATE_AZURE_VM_TEMPLATE_ACTION: "UPDATE_AZURE_VM_TEMPLATE_ACTION",
  UPDATE_AZURE_VM_TEMPLATE_SUCCESS: "UPDATE_AZURE_VM_TEMPLATE_SUCCESS",
  UPDATE_AZURE_VM_TEMPLATE_ERROR: "UPDATE_AZURE_VM_TEMPLATE_ERROR",
  UPDATE_AZURE_VM_TEMPLATE_RESET: "UPDATE_AZURE_VM_TEMPLATE_RESET",

  FETCH_AZURE_VM_TEMPLATE_ACTION: "FETCH_AZURE_VM_TEMPLATE_ACTION",
  FETCH_AZURE_VM_TEMPLATE_SUCCESS: "FETCH_AZURE_VM_TEMPLATE_SUCCESS",
  FETCH_AZURE_VM_TEMPLATE_ERROR: "FETCH_AZURE_VM_TEMPLATE_ERROR",
  FETCH_AZURE_VM_TEMPLATE_RESET: "FETCH_AZURE_VM_TEMPLATE_RESET",

  LIST_AZURE_VM_TEMPLATES_ACTION: "LIST_AZURE_VM_TEMPLATES_ACTION",
  LIST_AZURE_VM_TEMPLATES_SUCCESS: "LIST_AZURE_VM_TEMPLATES_SUCCESS",
  LIST_AZURE_VM_TEMPLATES_ERROR: "LIST_AZURE_VM_TEMPLATES_ERROR",
  LIST_AZURE_VM_TEMPLATES_RESET: "LIST_AZURE_VM_TEMPLATES_RESET",

  DELETE_AZURE_VM_TEMPLATE_ACTION: "DELETE_AZURE_VM_TEMPLATE_ACTION",
  DELETE_AZURE_VM_TEMPLATE_SUCCESS: "DELETE_AZURE_VM_TEMPLATE_SUCCESS",
  DELETE_AZURE_VM_TEMPLATE_ERROR: "DELETE_AZURE_VM_TEMPLATE_ERROR",
  DELETE_AZURE_VM_TEMPLATE_RESET: "DELETE_AZURE_VM_TEMPLATE_RESET",

  PUBLISH_AZURE_VM_TEMPLATE_ACTION: "PUBLISH_AZURE_VM_TEMPLATE_ACTION",
  PUBLISH_AZURE_VM_TEMPLATE_SUCCESS: "PUBLISH_AZURE_VM_TEMPLATE_SUCCESS",
  PUBLISH_AZURE_VM_TEMPLATE_ERROR: "PUBLISH_AZURE_VM_TEMPLATE_ERROR",
  PUBLISH_AZURE_VM_TEMPLATE_RESET: "PUBLISH_AZURE_VM_TEMPLATE_RESET",

  LIST_AZURE_SKUS_ACTION: "LIST_AZURE_SKUS_ACTION",
  LIST_AZURE_SKUS_SUCCESS: "LIST_AZURE_SKUS_SUCCESS",
  LIST_AZURE_SKUS_ERROR: "LIST_AZURE_SKUS_ERROR",
  LIST_AZURE_SKUS_RESET: "LIST_AZURE_SKUS_RESET",

  CREATE_AZURE_SKU_ACTION: "CREATE_AZURE_SKU_ACTION",
  CREATE_AZURE_SKU_SUCCESS: "CREATE_AZURE_SKU_SUCCESS",
  CREATE_AZURE_SKU_ERROR: "CREATE_AZURE_SKU_ERROR",
  CREATE_AZURE_SKU_RESET: "CREATE_AZURE_SKU_RESET",

  UPDATE_AZURE_SKU_ACTION: "UPDATE_AZURE_SKU_ACTION",
  UPDATE_AZURE_SKU_SUCCESS: "UPDATE_AZURE_SKU_SUCCESS",
  UPDATE_AZURE_SKU_ERROR: "UPDATE_AZURE_SKU_ERROR",
  UPDATE_AZURE_SKU_RESET: "UPDATE_AZURE_SKU_RESET",
}

export const userMachineCatalogueActions = {
  FETCH_CATALOG_LABS_LIST_DATA: "FETCH_CATALOG_LABS_LIST_DATA",
  SET_CATALOG_LABS_LIST_DATA: "SET_CATALOG_LABS_LIST_DATA",
  SET_CATALOG_LABS_LIST_ERROR: "SET_CATALOG_LABS_LIST_ERROR",
  LAB_VIEW_REQUEST: "LAB_VIEW_REQUEST",
  LAB_VIEW_SUCCESS: "LAB_VIEW_SUCCESS",
  LAB_VIEW_ERROR: "LAB_VIEW_ERROR",
  CREATE_VM_REQUEST: "CREATE_VM_REQUEST",
  CREATE_VM_SUCCESS: "CREATE_VM_SUCCESS",
  CREATE_VM_ERROR: "CREATE_VM_ERROR",
  REMOVE_SELECTED_LAB: "REMOVE_SELECTED_LAB",
  SET_VM_ADD_STATUS: "SET_VM_ADD_STATUS",
  QUOTA_RESET_VALUE_REQUEST: "QUOTA_RESET_VALUE_REQUEST",
  QUOTA_RESET_VALUE_SUCCESS: "QUOTA_RESET_VALUE_SUCCESS",
  QUOTA_RESET_VALUE_ERROR: "QUOTA_RESET_VALUE_ERROR",
  REQUEST_CLOUD_CATALOG_LIST: "REQUEST_CLOUD_CATALOG_LIST",
  SUCCESS_CLOUD_CATALOG_LIST: "SUCCESS_CLOUD_CATALOG_LIST",
  ERROR_CLOUD_CATALOG_LIST: "ERROR_CLOUD_CATALOG_LIST",
  REQUEST_CLOUD_CATALOG: "REQUEST_CLOUD_CATALOG",
  SUCCESS_CLOUD_CATALOG: "SUCCESS_CLOUD_CATALOG",
  ERROR_CLOUD_CATALOG: "ERROR_CLOUD_CATALOG",
  REQUEST_CLOUD_LAB_EXTENSION: "REQUEST_CLOUD_LAB_EXTENSION",
  SUCCESS_CLOUD_LAB_EXTENSION: "SUCCESS_CLOUD_LAB_EXTENSION",
  ERROR_CLOUD_LAB_EXTENSION: "ERROR_CLOUD_LAB_EXTENSION",
  REQUEST_CREATE_CLOUD_LAB: "REQUEST_CREATE_CLOUD_LAB",
  SUCCESS_CREATE_CLOUD_LAB: "SUCCESS_CREATE_CLOUD_LAB",
  ERROR_CREATE_CLOUD_LAB: "ERROR_CREATE_CLOUD_LAB",
  REQUEST_CLOUD_LAB_LIST: "REQUEST_CLOUD_LAB_LIST",
  SUCCESS_CLOUD_LAB_LIST: "SUCCESS_CLOUD_LAB_LIST",
  ERROR_CLOUD_LAB_LIST: "ERROR_CLOUD_LAB_LIST",
  REQUEST_CREATE_CLOUD_LAB_FEEDBACK: "REQUEST_CREATE_CLOUD_LAB_FEEDBACK",
  SUCCESS_CREATE_CLOUD_LAB_FEEDBACK: "SUCCESS_CREATE_CLOUD_LAB_FEEDBACK",
  ERROR_CREATE_CLOUD_LAB_FEEDBACK: "ERROR_CREATE_CLOUD_LAB_FEEDBACK",
  REQUEST_UPDATE_CLOUD_LAB_FEEDBACK: "REQUEST_UPDATE_CLOUD_LAB_FEEDBACK",
  SUCCESS_UPDATE_CLOUD_LAB_FEEDBACK: "SUCCESS_UPDATE_CLOUD_LAB_FEEDBACK",
  ERROR_UPDATE_CLOUD_LAB_FEEDBACK: "ERROR_UPDATE_CLOUD_LAB_FEEDBACK",
  CREATE_VM_REQUEST_ADMIN: "CREATE_VM_REQUEST_ADMIN",
  GET_BASE_TEMPLATES_LIST: "GET_BASE_TEMPLATES_LIST",
  SET_BASE_TEMPLATES_LIST: "SET_BASE_TEMPLATES_LIST",
  LOADING_BASE_TEMPLATE_LIST: "LOADING_BASE_TEMPLATE_LIST",
  UPDATE_BASE_TEMPLATE: "UPDATE_BASE_TEMPLATE",
  UPDATE_BASE_TEMPLATE_SUCCESS: "UPDATE_BASE_TEMPLATE_SUCCESS",
  UPDATE_BASE_TEMPLATE_ERROR: "UPDATE_BASE_TEMPLATE_ERROR",
  UPDATE_BASE_TEMPLATE_LOADING: "UPDATE_BASE_TEMPLATE_LOADING",
  GET_EXTENSION_AND_BASE_PACKS_ACTION: "GET_EXTENSION_AND_BASE_PACKS_ACTION",
  SET_EXTENSION_AND_BASE_PACKS_ACTION: "SET_EXTENSION_AND_BASE_PACKS_ACTION",
  SET_EXTENSION_AND_BASE_PACKS_LOADING_ACTION:
    "SET_EXTENSION_AND_BASE_PACKS_LOADING_ACTION",
  APPLY_LAB_EXTENSION: "APPLY_LAB_EXTENSION",
  APPLY_LAB_EXTENSION_SUCCESS: "APPLY_LAB_EXTENSION_SUCCESS",
  APPLY_LAB_EXTENSION_ERROR: "APPLY_LAB_EXTENSION_ERROR",
  APPLY_LAB_EXTENSION_LOADING: "APPLY_LAB_EXTENSION_LOADING",
  SET_SELECTED_TEMPLATE_TYPE: "SET_SELECTED_TEMPLATE_TYPE",
  EXPORT_SKU_TENANT_CATALOG: "EXPORT_SKU_TENANT_CATALOG",
  SUCCESS_EXPORT_SKU_TENANT_CATALOG: "SUCCESS_EXPORT_SKU_TENANT_CATALOG",
  ERROR_EXPORT_SKU_TENANT_CATALOG: "ERROR_EXPORT_SKU_TENANT_CATALOG",
  CLEAR_EXPORT_SKU_TENANT_CATALOG: "CLEAR_EXPORT_SKU_TENANT_CATALOG",

  APPLY_CLOUD_LAB_EXTENSION_LOADING: "APPLY_CLOUD_LAB_EXTENSION_LOADING",
  APPLY_CLOUD_LAB_EXTENSION_ACTION: "APPLY_CLOUD_LAB_EXTENSION_ACTION",
  APPLY_CLOUD_LAB_EXTENSION_SUCCESS: "APPLY_CLOUD_LAB_EXTENSION_SUCCESS",
  APPLY_CLOUD_LAB_EXTENSION_ERROR: "APPLY_CLOUD_LAB_EXTENSION_ERROR",
  APPLY_CLOUD_LAB_EXTENSION_RESET: "APPLY_CLOUD_LAB_EXTENSION_RESET",
};

export const common = {
  ADDRESS_GET_REQUEST: "ADDRESS_GET_REQUEST",
  COUNTRY_LIST_GET_SUCCESS: "COUNTRY_LIST_GET_SUCCESS",
  STATE_LIST_GET_SUCCESS: "STATE_LIST_GET_SUCCESS",
  CITY_LIST_GET_SUCCESS: "CITY_LIST_GET_SUCCESS",
  COMMON_LOADER_GET_REQUEST: "COMMON_LOADER_GET_REQUEST",
  COMMON_LOADER_GET_SUCCESS: "COMMON_LOADER_GET_SUCCESS",
  GET_WEBSOCKET_TICKET: "GET_WEBSOCKET_TICKET",
  SET_WEBSOCKET_TICKET: "SET_WEBSOCKET_TICKET",
  GET_NOTIFICATION_WEBSOCKET_TICKET: "GET_NOTIFICATION_WEBSOCKET_TICKET",
  SET_NOTIFICATION_WEBSOCKET_TICKET: "SET_NOTIFICATION_WEBSOCKET_TICKET",
  CLEAR_TICKET: "CLEAR_TICKET",
  GET_DASHBOARD_WEBSOCKET_TICKET: "GET_DASHBOARD_WEBSOCKET_TICKET",
  SET_DASHBOARD_WEBSOCKET_TICKET: "SET_DASHBOARD_WEBSOCKET_TICKET",
  SET_IS_DARK_THEME: "SET_IS_DARK_THEME",
  SET_IS_SIDEBAR_COLLAPSE: "SET_IS_SIDEBAR_COLLAPSE",
  SET_IS_SIDEBAR_HIDDEN: "SET_IS_SIDEBAR_HIDDEN",
};

export const notificationManagement = {
  NOTIFICATION_MANAGEMENT_GET_REQUEST: "NOTIFICATION_MANAGEMENT_GET_REQUEST",
  NOTIFICATION_GET_MANAGEMENT_SUCCESS: "NOTIFICATION_GET_MANAGEMENT_SUCCESS",
  NOTIFICATION_MANGEMENT_GET_ERROR: "NOTIFICATION_MANGEMENT_GET_ERROR",
  NOTIFICATION_MANAGEMENT_CREATE_REQUEST:
    "NOTIFICATION_MANAGEMENT_CREATE_REQUEST",
  NOTIFICATION_MANAGEMENT_CREATE_SUCCESS:
    "NOTIFICATION_MANAGEMENT_CREATE_SUCCESS",
  NOTIFICATION_MANAGEMENT_CREATE_ERROR: "NOTIFICATION_MANAGEMENT_CREATE_ERROR",
  NOTIFICATION_MANAGEMENT_UPDATE_REQUEST:
    "NOTIFICATION_MANAGEMENT_UPDATE_REQUEST",
  NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS:
    "NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS",
  NOTIFICATION_MANAGEMENT_UPDATE_ERROR: "NOTIFICATION_MANAGEMENT_UPDATE_ERROR",
  MY_NOTIFICATION_MANGEMENT_GET_SUCCESS:
    "MY_NOTIFICATION_MANGEMENT_GET_SUCCESS",
  USERS_NOTIFICATION_MANGEMENT_GET_SUCCESS:
    "USERS_NOTIFICATION_MANGEMENT_GET_SUCCESS",
  NOTIFICATION_MANAGEMENT_DELETE_REQUEST:
    "NOTIFICATION_MANAGEMENT_DELETE_REQUEST",
  NOTIFICATION_MANAGEMENT_DELETE_SUCCESS:
    "NOTIFICATION_MANAGEMENT_DELETE_SUCCESS",
  NOTIFICATION_MANAGEMENT_DELETE_ERROR: "NOTIFICATION_MANAGEMENT_DELETE_ERROR",
  NOTIFICATION_MANAGEMENT_DEFAULT_SUCCESS:
    "NOTIFICATION_MANAGEMENT_DEFAULT_SUCCESS",
  NOTIFICATION_MANAGEMENT_SEND_SUCCESS: "NOTIFICATION_MANAGEMENT_SEND_SUCCESS",
  NOTIFICATION_MANAGEMENT_SEND_ERROR: "NOTIFICATION_MANAGEMENT_SEND_ERROR",
  NOTIFICATION_MANAGEMENT_SEND_REQUEST: "NOTIFICATION_MANAGEMENT_SEND_REQUEST",
};

export const headerNotifications = {
  USER_NOTIFICATION_LIST_GET_DATA: "USER_NOTIFICATION_LIST_GET_DATA",
  USER_NOTIFICATION_LIST_SET_DATA: "USER_NOTIFICATION_LIST_SET_DATA",
  USER_NOTIFICATION_LIST_SET_ERROR: "USER_NOTIFICATION_LIST_SET_ERROR",
  USER_NOTIFICATION_UPDATE_READ_STATUS: "USER_NOTIFICATION_UPDATE_READ_STATUS",
  USER_NOTIFICATION_READ_STATUS_SUCCESS:
    "USER_NOTIFICATION_READ_STATUS_SUCCESS",
  USER_NOTIFICATION_READ_STATUS_FAILURE:
    "USER_NOTIFICATION_READ_STATUS_FAILURE",
  USER_NOTIFICATION_LIST_SET_DATA_WS: "USER_NOTIFICATION_LIST_SET_DATA_WS",
};

export const requestManagerActions = {
  REQUESTS_LIST_REQUEST: "REQUESTS_LIST_REQUEST",
  REQUESTS_LIST_SUCCESS: "REQUESTS_LIST_SUCCESS",
  REQUESTS_LIST_ERROR: "REQUESTS_LIST_ERROR",
  REQUEST_TRACK_REQUEST: "REQUEST_TRACK_REQUEST",
  SUCCESS_TRACK_REQUEST: "SUCCESS_TRACK_REQUEST",
  ERROR_TRACK_REQUEST: "ERROR_TRACK_REQUEST",
  APPROVE_DECLINE_SUCCESS: "APPROVE_DECLINE_SUCCESS",
  APPROVE_DECLINE_REQUEST: "APPROVE_DECLINE_REQUEST",
  APPROVE_DECLINE_ERROR: "APPROVE_DECLINE_ERROR",
  REQUESTS_LIST_CLEAR: "REQUESTS_LIST_CLEAR",
  DEPLOYMENT_LIST_REQUEST: "DEPLOYMENT_LIST_REQUEST",
  DEPLOYMENT_LIST_SUCCESS: "DEPLOYMENT_LIST_SUCCESS",
  DEPLOYMENT_LIST_ERROR: "DEPLOYMENT_LIST_ERROR",
  RETRIEVE_REQUEST: "RETRIEVE_REQUEST",
  SUCCESS_REQUEST: "SUCCESS_REQUEST",
  ERROR_REQUEST: "ERROR_REQUEST",
  RETRIEVE_DEPLOYMENT_JOBS: "RETRIEVE_DEPLOYMENT_JOBS",
  SUCCESS_DEPLOYMENT_JOBS: "SUCCESS_DEPLOYMENT_JOBS",
  ERROR_DEPLOYMENT_JOBS: "ERROR_DEPLOYMENT_JOBS",
  REMOVE_DEPLOYMENT_JOBS: "REMOVE_DEPLOYMENT_JOBS",
  SET_DEPLOYMENT_DATA: "SET_DEPLOYMENT_DATA",
  GET_REQUEST_LAB: "GET_REQUEST_LAB",
  SUCCESS_REQUEST_LAB: "SUCCESS_REQUEST_LAB",
  ERROR_REQUEST_LAB: "ERROR_REQUEST_LAB",
  SET_REQUEST_TICKET: "SET_REQUEST_TICKET",
  SUCCESS_REQUEST_TICKET: "SUCCESS_REQUEST_TICKET",
  ERROR_REQUEST_TICKET: "ERROR_REQUEST_TICKET",
  SET_APPROVE_DECLINE_REQUEST: "SET_APPROVE_DECLINE_REQUEST",
  SUCCESS_APPROVE_DECLINE_REQUEST: "SUCCESS_APPROVE_DECLINE_REQUEST",
  ERROR_APPROVE_DECLINE_REQUEST: "ERROR_APPROVE_DECLINE_REQUEST",
  REQUEST_DELETE_REQUEST_TICKET: "REQUEST_DELETE_REQUEST_TICKET",
  SUCCESS_DELETE_REQUEST_TICKET: "SUCCESS_DELETE_REQUEST_TICKET",
  ERROR_DELETE_REQUEST_TICKET: "ERROR_DELETE_REQUEST_TICKET",
  RESEND_NOTIFICATION_RETRIEVE_REQUEST: "RESEND_NOTIFICATION_RETRIEVE_REQUEST",
  RESEND_NOTIFICATION_RETRIEVE_SUCCESS: "RESEND_NOTIFICATION_RETRIEVE_SUCCESS",
  RESEND_NOTIFICATION_RETRIEVE_ERROR: "RESEND_NOTIFICATION_RETRIEVE_ERROR",
  REQUEST_NOTIFY_AGAIN: "REQUEST_NOTIFY_AGAIN",
  SUCCESS_NOTIFY_AGAIN: "SUCCESS_NOTIFY_AGAIN",
  ERROR_NOTIFY_AGAIN: "ERROR_NOTIFY_AGAIN",
  // Export Request
  EXPORT_REQUEST_ACTION: "EXPORT_REQUEST_ACTION",
  EXPORT_REQUEST_SUCCESS: "EXPORT_REQUEST_SUCCESS",
  EXPORT_REQUEST_ERROR: "EXPORT_REQUEST_ERROR",
  EXPORT_REQUEST_RESET: "EXPORT_REQUEST_RESET",
  EXPORT_REQUEST_LOADING: "EXPORT_REQUEST_LOADING",

  BULK_UPDATE_REQUEST_ACTION: "BULK_UPDATE_REQUEST_ACTION",
  BULK_UPDATE_REQUEST_SUCCESS: "BULK_UPDATE_REQUEST_SUCCESS",
  BULK_UPDATE_REQUEST_ERROR: "BULK_UPDATE_REQUEST_ERROR",
  BULK_UPDATE_REQUEST_RESET: "BULK_UPDATE_REQUEST_RESET",
  BULK_UPDATE_REQUEST_LOADING: "BULK_UPDATE_REQUEST_LOADING",
};

export const actionLog = {
  REQUEST_ACTION_LOGS: "REQUEST_ACTION_LOGS",
  SUCCESS_ACTION_LOGS: "SUCCESS_ACTION_LOGS",
  ERROR_ACTION_LOGS: "ERROR_ACTION_LOGS",
  REQUEST_BETWEEN_DATES: "REQUEST_BETWEEN_DATES",
  SUCCESS_BETWEEN_DATES: "SUCCESS_BETWEEN_DATES",
  ERROR_BETWEEN_DATES: "ERROR_BETWEEN_DATES",
  REQUEST_ACTION_LOG_DOWNLOAD: "REQUEST_ACTION_LOG_DOWNLOAD",
  SUCCESS_ACTION_LOG_DOWNLOAD: "SUCCESS_ACTION_LOG_DOWNLOAD",
  ERROR_ACTION_LOG_DOWNLOAD: "ERROR_ACTION_LOG_DOWNLOAD",
};

export const notifications = {
  REQUEST_NOTIFICATIONS_LIST: "REQUEST_NOTIFICATIONS_LIST",
  SUCCESS_NOTIFICATIONS_LIST: "SUCCESS_NOTIFICATIONS_LIST",
  ERROR_NOTIFICATIONS_LIST: "ERROR_NOTIFICATIONS_LIST",
  REQUEST_READ_STATUS: "REQUEST_READ_STATUS",
  SUCCESS_READ_STATUS: "SUCCESS_READ_STATUS",
  ERROR_READ_STATUS: "ERROR_READ_STATUS",
  SET_READ_STATUS: "SET_READ_STATUS",
};

export const portalWalkthrough = {
  SET_STEPS: "SET_STEPS",
  START: "START",
  RESET: "RESET",
  STOP: "STOP",
  NEXT_OR_PREV: "NEXT_OR_PREV",
  RESTART: "RESTART",
};

export const notificationSettings = {
  REQUEST_NOTIFICATION_TYPES: "REQUEST_NOTIFICATION_TYPES",
  SUCCESS_NOTIFICATION_TYPES: "SUCCESS_NOTIFICATION_TYPES",
  ERROR_NOTIFICATION_TYPES: "ERROR_NOTIFICATION_TYPES",
  FETCH_NOTIFICATION_TYPES_LIST: "FETCH_NOTIFICATION_TYPES_LIST",
  FETCH_REPORT_NOTIFICATION_TYPE_LIST: "FETCH_REPORT_NOTIFICATION_TYPE_LIST",
  SUCCESS_REPORT_NOTIFICATION_TYPE_LIST:
    "SUCCESS_REPORT_NOTIFICATION_TYPE_LIST",
  ERROR_REPORT_NOTIFICATION_TYPE_LIST: "ERROR_REPORT_NOTIFICATION_TYPE_LIST",
  UPDATE_REPORT_NOTIFICATION_SETTINGS: "UPDATE_REPORT_NOTIFICATION_SETTINGS",
  SET_REPORT_NOTITFICATION_DATA: "SET_REPORT_NOTITFICATION_DATA",
  SUCCESS_UPDATE_REPORT_NOTIFICATION: "SUCCESS_UPDATE_REPORT_NOTIFICATION",
  SUCCESS_NOTIFICATION_TYPES_LIST: "SUCCESS_NOTIFICATION_TYPES_LIST",
  ERROR_NOTIFICATION_TYPES_LIST: "ERROR_NOTIFICATION_TYPES_LIST",
  UPDATE_NOTIFICATION_SETTINGS: "UPDATE_NOTIFICATION_SETTINGS",
  SUCCESS_NOTIFICATION_SETTINGS: "SUCCESS_NOTIFICATION_SETTINGS",
  ERROR_NOTIFICATION_SETTINGS: "ERROR_NOTIFICATION_SETTINGS",
  REQUEST_PHONE_NUMBER: "REQUEST_PHONE_NUMBER",
  SUCCESS_PHONE_NUMBER: "SUCCESS_PHONE_NUMBER",
  ERROR_PHONE_NUMBER: "ERROR_PHONE_NUMBER",
};

export const usage = {
  USAGE_SUMMARY_GET_DATA: "USAGE_SUMMARY_GET_DATA",
  USAGE_SUMMARY_SET_DATA: "USAGE_SUMMARY_SET_DATA",
  USAGE_SUMMARY_SET_ERROR: "USAGE_SUMMARY_SET_ERROR",
  SET_SUMMARY_LOADING: "SET_SUMMARY_LOADING",
  USAGE_REPORT_GENERATE_REQUEST: "USAGE_REPORT_GENERATE_REQUEST",
  USAGE_REPORT_GENERATE_SUCCESS: "USAGE_REPORT_GENERATE_SUCCESS",
  USAGE_REPORT_GENERATE_ERROR: "USAGE_REPORT_GENERATE_ERROR",
  SET_GENERATE_REPORT_LOADING: "SET_GENERATE_REPORT_LOADING",
  REPORT_LIST_GET_DATA: "REPORT_LIST_GET_DATA",
  REPORT_LIST_SET_DATA: "REPORT_LIST_SET_DATA",
  REPORT_LIST_SET_ERROR: "REPORT_LIST_SET_ERROR",
  SET_REPORT_LIST_LOADING: "SET_REPORT_LIST_LOADING",
  SET_WEBSOCKET_USAGE_LIST_DATA: "SET_WEBSOCKET_USAGE_LIST_DATA",

  // Get Report Sku's
  GET_REPORT_SKU_LOADING: "GET_REPORT_SKU_LOADING",
  GET_REPORT_SKU_ACTION: "GET_REPORT_SKU_ACTION",
  GET_REPORT_SKU_SUCCESS: "GET_REPORT_SKU_SUCCESS",
  GET_REPORT_SKU_ERROR: "GET_REPORT_SKU_ERROR",
  GET_REPORT_SKU_RESET: "GET_REPORT_SKU_RESET",

  // Usage User List
  GET_USAGE_USER_LIST_LOADING: "GET_USAGE_USER_LIST_LOADING",
  GET_USAGE_USER_LIST_ACTION: "GET_USAGE_USER_LIST_ACTION",
  GET_USAGE_USER_LIST_SUCCESS: "GET_USAGE_USER_LIST_SUCCESS",
  GET_USAGE_USER_LIST_ERROR: "GET_USAGE_USER_LIST_ERROR",
  GET_USAGE_USER_LIST_RESET: "GET_USAGE_USER_LIST_RESET",
};

export const publicUsageReport = {
  PUBLIC_REPORT_LIST_GET_DATA: "PUBLIC_REPORT_LIST_GET_DATA",
  PUBLIC_REPORT_LIST_SET_DATA: "PUBLIC_REPORT_LIST_SET_DATA",
  PUBLIC_REPORT_LIST_SET_ERROR: "PUBLIC_REPORT_LIST_SET_ERROR",
  SET_PUBLIC_REPORT_LIST_LOADING: "SET_PUBLIC_REPORT_LIST_LOADING",
  PUBLIC_USAGE_REPORT_GENERATE_REQUEST: "PUBLIC_USAGE_REPORT_GENERATE_REQUEST",
  PUBLIC_USAGE_REPORT_GENERATE_SUCCESS: "PUBLIC_USAGE_REPORT_GENERATE_SUCCESS",
  PUBLIC_USAGE_REPORT_GENERATE_ERROR: "PUBLIC_USAGE_REPORT_GENERATE_ERROR",
  SET_PUBLIC_GENERATE_REPORT_LOADING: "SET_PUBLIC_GENERATE_REPORT_LOADING",
};

export const workspaceManager = {
  GET_WORKSPACE_DASHBOARD_LIST: "GET_WORKSPACE_DASHBOARD_LIST",
  SET_WORKSPACE_DASHBOARD_LIST: "SET_WORKSPACE_DASHBOARD_LIST",
  REQUEST_WORKSPACE_DETAILS: "REQUEST_WORKSPACE_DETAILS",
  SUCCESS_WORKSPACE_DETAILS: "SUCCESS_WORKSPACE_DETAILS",
  ERROR_WORKSPACE_DETAILS: "ERROR_WORKSPACE_DETAILS",
  SET_WORKSPACE_DASHBOARD_LIST_ERROR: "SET_WORKSPACE_DASHBOARD_LIST_ERROR",
  SET_WORKSPACE_LIST_LOADING: "SET_WORKSPACE_LIST_LOADING",
  GET_PUBLIC_WORKSPACE_RESOURCE_LIST: "GET_PUBLIC_WORKSPACE_RESOURCE_LIST",
  SET_PUBLIC_WORKSPACE_RESOURCE_LIST: "SET_PUBLIC_WORKSPACE_RESOURCE_LIST",
  SET_PUBLIC_WORKSPACE_RESOURCE_LIST_ERROR: "SET_PUBLIC_WORKSPACE_RESOURCE_LIST_ERROR",
  SET_PUBLIC_WORKSPACE_LIST_LOADING: "SET_PUBLIC_WORKSPACE_LIST_LOADING",
  REQUEST_WORKSPACE_DETAILS_USERS: "REQUEST_WORKSPACE_DETAILS_USERS",
  SUCCESS_WORKSPACE_DETAILS_USERS: "SUCCESS_WORKSPACE_DETAILS_USERS",
  RESET_WORKSPACE_DETAILS_USERS: "RESET_WORKSPACE_DETAILS_USERS",
  ERROR_WORKSPACE_DETAILS_USERS: "ERROR_WORKSPACE_DETAILS_USERS",
  CREATE_AUTH_CONFIG: "CREATE_AUTH_CONFIG",
  EDIT_AUTH_CONFIG: "EDIT_AUTH_CONFIG",
  ADD_RESOURCE: "ADD_RESOURCE",
  EDIT_RESOURCE: "EDIT_RESOURCE",
  SET_WORKSPACE_RESOURCE: "SET_WORKSPACE_RESOURCE",
  CREATE_WORKSPACE: "CREATE_WORKSPACE",
  EDIT_WORKSPACE: "EDIT_WORKSPACE",
  CREATE_WORKSPACE_SUCCESS: "CREATE_WORKSPACE_SUCCESS",
  CREATE_WORKSPACE_ERROR: "CREATE_WORKSPACE_ERROR",
  ADD_RESOURCE_SUCCESS: "ADD_RESOURCE_SUCCESS",
  ADD_RESOURCE_ERROR: "ADD_RESOURCE_ERROR",
  CREATE_AUTH_CONFIG_SUCCESS: "CREATE_AUTH_CONFIG_SUCCESS",
  CREATE_AUTH_CONFIG_ERROR: "CREATE_AUTH_CONFIG_ERROR",
  SET_WORKSPACE_AUTH_CONFIG: "SET_WORKSPACE_AUTH_CONFIG",
  SET_WORKSPACE_AUTH_CONFIG_ERROR: "SET_WORKSPACE_AUTH_CONFIG_ERROR",
  BUTTON_LOADING: "BUTTON_LOADING",
  GET_RESOURCE_TEMPLATE: "GET_RESOURCE_TEMPLATE",
  SET_RESOURCE_TEMPLATE: "SET_RESOURCE_TEMPLATE",
  CREATE_WORKSPACE_LOADING: "CREATE_WORKSPACE_LOADING",
  DELETE_WORKSPACE_REQUEST: "DELETE_WORKSPACE_REQUEST",
  DELETE_WORKSPACE_SUCCESS: "DELETE_WORKSPACE_SUCCESS",
  POST_API_SUCCESSSFUL: "POST_API_SUCCESSSFUL",
  SET_ACTIVE_WORKSPACE: "SET_ACTIVE_WORKSPACE",
  SET_WORKSPACE_LOADING: "SET_WORKSPACE_LOADING",
  GET_WORKSPACE_BY_ID: "GET_WORKSPACE_BY_ID",
  SET_INSTANCE_SIZE_PRICING: "SET_INSTANCE_SIZE_PRICING",
  GET_INSTANCE_SIZE_PRICING: "GET_INSTANCE_SIZE_PRICING",
  INSTANCE_SIZE_PRICING_LOADING: "INSTANCE_SIZE_PRICING_LOADING",
  RESET_WORKSPACE_FORM: "RESET_WORKSPACE_FORM",
  GET_WORKSPACE_RESOURCE_BY_ID: "GET_WORKSPACE_RESOURCE_BY_ID",
  GET_WORKSPACE_AUTH_CONFIG_BY_ID: "GET_WORKSPACE_AUTH_CONFIG_BY_ID",
  SET_AUTH_LOADING: "SET_AUTH_LOADING",
  SET_RESOURCE_LOADING: "SET_RESOURCE_LOADING",
  SET_RES_TEMPLATE_LOADING: "SET_RES_TEMPLATE_LOADING",
  WORKSPACE_ACTION_REQUEST: "WORKSPACE_ACTION_REQUEST",
  WORKSPACE_ACTION_SUCCESS: "WORKSPACE_ACTION_SUCCESS",
  GET_WORKSPACE_RESOURCE_LIST: "GET_WORKSPACE_RESOURCE_LIST",
  SET_WORKSPACE_RESOURCE_LIST: "SET_WORKSPACE_RESOURCE_LIST",
  SET_WORKSPACE_RESOURCE_LIST_ERROR: "SET_WORKSPACE_RESOURCE_LIST_ERROR",
  LINK_DELINK_RESOURCE: "LINK_DELINK_RESOURCE",
  LIST_USER_INVITATION: "LIST_USER_INVITATION",
  SET_USER_INVITATION: "SET_USER_INVITATION",
  SET_USER_INVITATION_LOADING: "SET_USER_INVITATION_LOADING",
  SET_LINK_DELINK_LOADING: "SET_LINK_DELINK_LOADING",
  SET_LINK_DELINK_SUCCESS: "SET_LINK_DELINK_SUCCESS",
  REQUEST_DELETE_WORKSPACE_USER: "REQUEST_DELETE_WORKSPACE_USER",
  SUCCESS_DELETE_WORKSPACE_USER: "SUCCESS_DELETE_WORKSPACE_USER",
  ERROR_DELETE_WORKSPACE_USER: "ERROR_DELETE_WORKSPACE_USER",
  REQUEST_DOWNLOAD_INVITATION: "REQUEST_DOWNLOAD_INVITATION",
  SUCCESS_DOWNLOAD_INVITATION: "SUCCESS_DOWNLOAD_INVITATION",
  ERROR_DOWNLOAD_INVITATION: "ERROR_DOWNLOAD_INVITATION",
  GENERATE_INVITE_LOADING: "GENERATE_INVITE_LOADING",
  SET_INVITE_LINK: "SET_INVITE_LINK",
  GENERATE_INVITE_LINK: "GENERATE_INVITE_LINK",
  EDIT_WORKSPACE_SUCCESS: "EDIT_WORKSPACE_SUCCESS",
  CLEAR_DOWNLOAD_INVITATION: "CLEAR_DOWNLOAD_INVITATION",
  REQUEST_RESEND_INVITATION: "REQUEST_RESEND_INVITATION",
  SUCCESS_RESEND_INVITATION: "SUCCESS_RESEND_INVITATION",
  ERROR_RESEND_INVITATION: "ERROR_RESEND_INVITATION",
  REQUEST_TENANT_LIST_USAGE: "REQUEST_TENANT_LIST_USAGE",
  SUCCESS_TENANT_LIST_USAGE: "SUCCESS_TENANT_LIST_USAGE",
  ERROR_TENANT_LIST_USAGE: "ERROR_TENANT_LIST_USAGE",
  REQUEST_WORKSPACES: "REQUEST_WORKSPACES",
  SUCCESS_WORKSPACES: "SUCCESS_WORKSPACES",
  ERROR_WORKSPACES: "ERROR_WORKSPACES",
  REQUEST_GENERATE_REPORT_LIST: "REQUEST_GENERATE_REPORT_LIST",
  SUCCESS_GENERATE_REPORT_LIST: "SUCCESS_GENERATE_REPORT_LIST",
  ERROR_GENERATE_REPORT_LIST: "ERROR_GENERATE_REPORT_LIST",
  REQUEST_GENERATE_REPORT: "REQUEST_GENERATE_REPORT",
  RESET_GENERATE_REPORT: "RESET_GENERATE_REPORT",
  SUCCESS_GENERATE_REPORT: "SUCCESS_GENERATE_REPORT",
  ERROR_GENERATE_REPORT: "ERROR_GENERATE_REPORT",
  GET_WORKSPACE_VERIFIED: "GET_WORKSPACE_VERIFIED",
  SET_WORKSPACE_VERIFIED: "SET_WORKSPACE_VERIFIED",
  SET_WORKSPACE_VERIFIED_ERROR: "SET_WORKSPACE_VERIFIED_ERROR",
  SET_INVITE_LINK_AVAILABLE: "SET_INVITE_LINK_AVAILABLE",
  SET_WEBSOCKET_WORKSPACE_RESOURCE_LIST:
    "SET_WEBSOCKET_WORKSPACE_RESOURCE_LIST",
  GET_INVITATION: "GET_INVITATION",
  SET_INVITATION: "SET_INVITATION",
  SET_INVITATION_ERROR: "SET_INVITATION_ERROR",
  LOCAL_USER_LOGIN: "LOCAL_USER_LOGIN",
  LOCAL_USER_LOGIN_SUCCESS: "LOCAL_USER_LOGIN_SUCCESS",
  LOCAL_USER_LOGIN_ERROR: "LOCAL_USER_LOGIN_ERROR",
  GET_WORKSPACE_EXT_PACKS: "GET_WORKSPACE_EXT_PACKS",
  AAD_USER_LOGIN: "AAD_USER_LOGIN",
  AAD_USER_LOGIN_SUCCESS: "AAD_USER_LOGIN_SUCCESS",
  AAD_USER_LOGIN_ERROR: "AAD_USER_LOGIN_ERROR",
  GET_WS_AUTH_RES: "GET_WS_AUTH_RES",
  WS_AUTH_RES_SUCCESS: "WS_AUTH_RES_SUCCESS",
  WS_AUTH_RES_ERROR: "WS_AUTH_RES_ERROR",
  TENANT_LIST_FOR_WORKSPACE: "TENANT_LIST_FOR_WORKSPACE",
  SET_TENANT_LIST_FOR_WORKSPACE: "SET_TENANT_LIST_FOR_WORKSPACE",
  REQUEST_WORKSPACE_ADD_USER: "REQUEST_WORKSPACE_ADD_USER",
  SUCCESS_WORKSPACE_ADD_USER: "SUCCESS_WORKSPACE_ADD_USER",
  ERROR_WORKSPACE_ADD_USER: "ERROR_WORKSPACE_ADD_USER",
  REQUEST_WORKSPACE_EDIT_USER: "REQUEST_WORKSPACE_EDIT_USER",
  SUCCESS_WORKSPACE_EDIT_USER: "SUCCESS_WORKSPACE_EDIT_USER",
  ERROR_WORKSPACE_EDIT_USER: "ERROR_WORKSPACE_EDIT_USER",
  CLEAR_WORKSPACE_ADD_USER: "CLEAR_WORKSPACE_ADD_USER",
  ADD_WORKSPACE_RESOURCES_ACTION: "ADD_WORKSPACE_RESOURCES_ACTION",
  ADD_WORKSPACE_RESOURCES_SUCCESS: "ADD_WORKSPACE_RESOURCES_SUCCESS",
  ADD_WORKSPACE_RESOURCES_ERROR: "ADD_WORKSPACE_RESOURCES_ERROR",
  ADD_WORKSPACE_RESOURCES_RESET: "ADD_WORKSPACE_RESOURCES_RESET",
  ADD_WORKSPACE_RESOURCES_LOADING: "ADD_WORKSPACE_RESOURCES_LOADING",

  GET_ALL_CLOUD_VM_SKU_LOADING: "GET_ALL_CLOUD_VM_SKU_LOADING",
  GET_ALL_CLOUD_VM_SKU_ACTION: "GET_ALL_CLOUD_VM_SKU_ACTION",
  GET_ALL_CLOUD_VM_SKU_SUCCESS: "GET_ALL_CLOUD_VM_SKU_SUCCESS",
  GET_ALL_CLOUD_VM_SKU_ERROR: "GET_ALL_CLOUD_VM_SKU_ERROR",
  GET_ALL_CLOUD_VM_SKU_RESET: "GET_ALL_CLOUD_VM_SKU_RESET",

  GET_ALL_CLOUD_VM_INSTANCE_LOADING: "GET_ALL_CLOUD_VM_INSTANCE_LOADING",
  GET_ALL_CLOUD_VM_INSTANCE_ACTION: "GET_ALL_CLOUD_VM_INSTANCE_ACTION",
  GET_ALL_CLOUD_VM_INSTANCE_SUCCESS: "GET_ALL_CLOUD_VM_INSTANCE_SUCCESS",
  GET_ALL_CLOUD_VM_INSTANCE_ERROR: "GET_ALL_CLOUD_VM_INSTANCE_ERROR",
  GET_ALL_CLOUD_VM_INSTANCE_RESET: "GET_ALL_CLOUD_VM_INSTANCE_RESET",
};

export const userWorkspaceManager = {
  GET_USER_WORKSPACE_DASHBOARD_LIST: "GET_USER_WORKSPACE_DASHBOARD_LIST",
  SET_USER_WORKSPACE_DASHBOARD_LIST: "SET_USER_WORKSPACE_DASHBOARD_LIST",
  SET_USER_WORKSPACE_DASHBOARD_LIST_ERROR:
    "SET_USER_WORKSPACE_DASHBOARD_LIST_ERROR",
  SET_USER_WORKSPACE_LIST_LOADING: "SET_USER_WORKSPACE_LIST_LOADING",
  GET_USER_WORKSPACE_LAB_TIMER: "GET_USER_WORKSPACE_LAB_TIMER",
  SET_USER_WORKSPACE_LAB_TIMER: "SET_USER_WORKSPACE_LAB_TIMER",
  SET_WORKSPACE_VM_STATUS: "SET_WORKSPACE_VM_STATUS",
};

export const directLogin = {
  VERIFY_DIRECT_LOGIN_TENANT: "VERIFY_DIRECT_LOGIN_TENANT",
  DIRECT_LOGIN_TENANT_VERIFIED: "DIRECT_LOGIN_TENANT_VERIFIED",
  DIRECT_LOGIN_TENANT_FAIL: "DIRECT_LOGIN_TENANT_FAIL",
  GET_DIRECT_LOGIN_AAD_TOKEN: "GET_DIRECT_LOGIN_AAD_TOKEN",
  DIRECT_LOGIN_AUTO_ON_BOARD_FALSE_AAD: "DIRECT_LOGIN_AUTO_ON_BOARD_FALSE_AAD",
  DIRECT_LOGIN_AUTO_ON_BOARD_FALSE_IDP: "DIRECT_LOGIN_AUTO_ON_BOARD_FALSE_IDP",
  GET_DIRECT_LOGIN_TOKEN_AUTO_ON_BOARD_IDP:
    "GET_DIRECT_LOGIN_TOKEN_AUTO_ON_BOARD_IDP",
  DIRECT_LOGIN_FOR_LOCAL_USER: "DIRECT_LOGIN_FOR_LOCAL_USER",
  VERIFY_DIRECT_LOGIN_LOCAL_USER: "VERIFY_DIRECT_LOGIN_LOCAL_USER",
};

export const help = {
  REQUEST_API_DOC: "REQUEST_API_DOC",
  SUCCESS_API_DOC: "SUCCESS_API_DOC",
  ERROR_API_DOC: "ERROR_API_DOC",
};

export const vmInsight = {
  GET_VM_INSIGHT_LIST: "GET_VM_INSIGHT_LIST",
  SET_VM_INSIGHT_LIST: "SET_VM_INSIGHT_LIST",
  SET_VM_INSIGHT_LIST_ERROR: "SET_VM_INSIGHT_LIST_ERROR",
  GET_VM_INSIGHT_DETAILS_LIST: "GET_VM_INSIGHT_DETAILS_LIST",
  SET_VM_INSIGHT_DETAILS_LIST: "SET_VM_INSIGHT_DETAILS_LIST",
  SET_VM_INSIGHT_DETAILS_LIST_ERROR: "SET_VM_INSIGHT_DETAILS_LIST_ERROR",
  SET_VM_INSIGHT_LIST_LOADER: "SET_VM_INSIGHT_LIST_LOADER",
};

export const b2c = {
  REQUEST_GET_PLAN_LIST: "REQUEST_GET_PLAN_LIST",
  SUCCESS_GET_PLAN_LIST: "SUCCESS_GET_PLAN_LIST",
  ERROR_GET_PLAN_LIST: "ERROR_GET_PLAN_LIST",
  REQUEST_RETRIEVE_PLAN_LIST: "REQUEST_RETRIEVE_PLAN_LIST",
  RESET_RETRIEVE_PLAN_LIST: "RESET_RETRIEVE_PLAN_LIST",
  SUCCESS_RETRIEVE_PLAN_LIST: "SUCCESS_RETRIEVE_PLAN_LIST",
  ERROR_RETRIEVE_PLAN_LIST: "ERROR_RETRIEVE_PLAN_LIST",
  REQUEST_SET_PLAN_LIST: "REQUEST_SET_PLAN_LIST",
  SUCCESS_SET_PLAN_LIST: "SUCCESS_SET_PLAN_LIST",
  ERROR_SET_PLAN_LIST: "ERROR_SET_PLAN_LIST",
  REQUEST_DELETE_PLAN: "REQUEST_DELETE_PLAN",
  SUCCESS_DELETE_PLAN: "SUCCESS_DELETE_PLAN",
  ERROR_DELETE_PLAN: "ERROR_DELETE_PLAN",
  REQUEST_UPDATE_PLAN: "REQUEST_UPDATE_PLAN",
  SUCCESS_UPDATE_PLAN: "SUCCESS_UPDATE_PLAN",
  ERROR_UPDATE_PLAN: "ERROR_UPDATE_PLAN",
  CREATE_FREE_TRIAL_TEMPLATE: "CREATE_FREE_TRIAL_TEMPLATE",
  SUCCESS_FREE_TRIAL_TEMPLATE: "SUCCESS_FREE_TRIAL_TEMPLATE",
  ERROR_FREE_TRIAL_TEMPLATE: "ERROR_FREE_TRIAL_TEMPLATE",
  GET_B2C_CATALOGS_LIST: "GET_B2C_CATALOGS_LIST",
  SUCCESS_B2C_CATALOGS_LIST: "SUCCESS_B2C_CATALOGS_LIST",
  ERROR_B2C_CATALOGS_LIST: "ERROR_B2C_CATALOGS_LIST",
  CLEAR_B2C_CATALOGS_LIST: "CLEAR_B2C_CATALOGS_LIST",
  RETRIVE_B2C_CATALOG_LIST: "RETRIVE_B2C_CATALOG_LIST",
  SUCCESS_RETRIVE_B2C_CATALOG_LIST: "SUCCESS_RETRIVE_B2C_CATALOG_LIST",
  ERROR_RETRIVE_B2C_CATALOG_LIST: "ERROR_RETRIVE_B2C_CATALOG_LIST",
  REQUEST_UPDATE_CATALOG_B2C_PLAN_MAP: "REQUEST_UPDATE_CATALOG_B2C_PLAN_MAP",
  SUCCESS_UPDATE_CATALOG_B2C_PLAN_MAP: "SUCCESS_UPDATE_CATALOG_B2C_PLAN_MAP",
  ERROR_UPDATE_CATALOG_B2C_PLAN_MAP: "ERROR_UPDATE_CATALOG_B2C_PLAN_MAP",
  CLEAR_RETRIVE_B2C_CATALOG_LIST: "CLEAR_RETRIVE_B2C_CATALOG_LIST",
  GET_B2C_TRENDING_LABS: "GET_B2C_TRENDING_LABS",
  SUCCESS_B2C_TRENDING_LABS: "SUCCESS_B2C_TRENDING_LABS",
  ERROR_B2C_TRENDING_LABS: "ERROR_B2C_TRENDING_LABS",
  REQUEST_GET_LATEST_PURCHASES: "REQUEST_GET_LATEST_PURCHASES",
  SUCCESS_GET_LATEST_PURCHASES: "SUCCESS_GET_LATEST_PURCHASES",
  ERROR_GET_LATEST_PURCHASES: "ERROR_GET_LATEST_PURCHASES",
  GET_B2C_VM_LABS_LIST: "GET_B2C_VM_LABS_LIST",
  SUCCESS_B2C_VM_LABS_LIST: "SUCCESS_B2C_VM_LABS_LIST",
  ERROR_B2C_VM_LABS_LIST: "ERROR_B2C_VM_LABS_LIST",
  REQUEST_ADD_LAB_INTO_CART: "REQUEST_ADD_LAB_INTO_CART",
  SUCCESS_ADD_LAB_INTO_CART: "SUCCESS_ADD_LAB_INTO_CART",
  ERROR_ADD_LAB_INTO_CART: "ERROR_ADD_LAB_INTO_CART",
  CLEAR_ADD_LAB_INTO_CART: "CLEAR_ADD_LAB_INTO_CART",
  CLEAR_ADD_LAB_INTO_CART_ERROR: "CLEAR_ADD_LAB_INTO_CART_ERROR",
  RETRIVE_USER_CART_DETAILS: "RETRIVE_USER_CART_DETAILS",
  SUCCESS_USER_CART_DETAILS: "SUCCESS_USER_CART_DETAILS",
  ERROR_USER_CART_DETAILS: "ERROR_USER_CART_DETAILS",
  CLEAR_PLAN_ITEM: "CLEAR_PLAN_ITEM",
  REQUEST_DELETE_ITEM_TO_CART: "REQUEST_DELETE_ITEM_TO_CART",
  SUCCESS_DELETE_ITEM_TO_CART: "SUCCESS_DELETE_ITEM_TO_CART",
  ERROR_DELETE_ITEM_TO_CART: "ERROR_DELETE_ITEM_TO_CART",
  REQUEST_B2C_CHECKOUT: "REQUEST_B2C_CHECKOUT",
  SUCCESS_B2C_CHECKOUT: "SUCCESS_B2C_CHECKOUT",
  ERROR_B2C_CHECKOUT: "ERROR_B2C_CHECKOUT",
  CLEAR_B2C_CHECKOUT: "CLEAR_B2C_CHECKOUT",
  REQUEST_PAYMENT_CALLBACK: "REQUEST_PAYMENT_CALLBACK",
  SUCCESS_PAYMENT_CALLBACK: "SUCCESS_PAYMENT_CALLBACK",
  ERROR_PAYMENT_CALLBACK: "ERROR_PAYMENT_CALLBACK",
  CLEAR_PAYMENT_CALLBACK: "CLEAR_PAYMENT_CALLBACK",
  REQUEST_PAYMENT_RECEIPT: "REQUEST_PAYMENT_RECEIPT",
  SUCCESS_PAYMENT_RECEIPT: "SUCCESS_PAYMENT_RECEIPT",
  ERROR_PAYMENT_RECEIPT: "ERROR_PAYMENT_RECEIPT",
  CLEAR_PAYMENT_RECEIPT: "CLEAR_PAYMENT_RECEIPT",
  SET_B2C_WEB_SOCKET_DATA: "SET_B2C_WEB_SOCKET_DATA",
  LOADER_B2C_GET_REQUEST: "LOADER_B2C_GET_REQUEST",
  LOADER_B2C_GET_SUCCESS: "LOADER_B2C_GET_SUCCESS",
  REQUEST_APPLY_DISCOUNT: "REQUEST_APPLY_DISCOUNT",
  SUCCESS_APPLY_DISCOUNT: "SUCCESS_APPLY_DISCOUNT",
  ERROR_APPLY_DISCOUNT: "ERROR_APPLY_DISCOUNT",
};

export const invoices = {
  GET_INVOICES_LIST: "GET_INVOICES_LIST",
  SET_INVOICES_LIST_SUCCESS: "SET_INVOICES_LIST_SUCCESS",
  SET_INVOICES_LIST_ERROR: "SET_INVOICES_LIST_ERROR",
  SET_INVOICE_LOADER: "SET_INVOICE_LOADER",
  GENERATE_INVOICE: "GENERATE_INVOICE",
  SUCCESS_GENERATE_INVOICE: "SUCCESS_GENERATE_INVOICE",
  ERROR_GENERATE_INVOICE: "ERROR_GENERATE_INVOICE",
  UPLOAD_INVOICE_JSON: "UPLOAD_INVOICE_JSON",
  UPLOAD_INVOICE_JSON_SUCCESS: "UPLOAD_INVOICE_JSON_SUCCESS",
  UPLOAD_INVOICE_JSON_ERROR: "UPLOAD_INVOICE_JSON_ERROR",
  UPDATE_INVOICE_PAYMENT_STATUS: "UPDATE_INVOICE_PAYMENT_STATUS",
  UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS:
    "UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS",
  UPDATE_INVOICE_PAYMENT_STATUS_ERROR: "UPDATE_INVOICE_PAYMENT_STATUS_ERROR",
};
// Added for ResellerLicense
export const resellerLicense = {
  GET_RESELLERLICENSE_LIST: "GET_RESELLERLICENSE_LIST",
  SUCCESS_GET_RESELLERLICENSE_LIST: "SUCCESS_GET_RESELLERLICENSE_LIST",
  ERROR_GET_RESELLERLICENSE_LIST: "ERROR_GET_RESELLERLICENSE_LIST",
  GET_RESELLERLICENSE_ITEM: "GET_RESELLERLICENSE_ITEM",
  SUCCESS_GET_RESELLERLICENSE_ITEM: "SUCCESS_GET_RESELLERLICENSE_ITEM",
  ERROR_GET_RESELLERLICENSE_ITEM: "ERROR_GET_RESELLERLICENSE_ITEM",
  REQUEST_DELETE_LICENSE: ".REQUEST_DELETE_LICENSE",
  REQUEST_UPDATE_LICENSE: "REQUEST_UPDATE_LICENSE",
  REQUEST_SET_LICENSE: "REQUEST_SET_LICENSE",
  ERROR_UPDATE_LICENSE: "ERROR_UPDATE_LICENSE",
  CLEAR_RESELLER_LICENSE: "CLEAR_RESELLER_LICENSE",
  SUCCESS_SET_LICENSE: "SUCCESS_SET_LICENSE",
  ERROR_SET_LICENSE: "SUCCESS_SET_LICENSE",
  GET_LICENSE_SUMMARY: "GET_LICENSE_SUMMARY",
  SET_LICENSE_SUMMARY: "GET_LICENSE_SUMMARY",
  ERROR_LICENSE_SUMMARY: "ERROR_LICENSE_SUMMARY",
  SUCCESS_DELETE_LICENSE: "SUCCESS_DELETE_LICENSE",
  ERROR_DELETE_LICENSE: "ERROR_DELETE_LICENSE",
  SUCCESS_UPDATE_LICENSE: "SUCCESS_UPDATE_LICENSE",
  RESELLERLICENSE_LIST_SET_DATA: "RESELLERLICENSE_LIST_SET_DATA",
  RESELLERLICENSE_LIST_UPDATE_DATA: "RESELLERLICENSE_LIST_UPDATE_DATA",
  LICENSE_EDIT_SUCCESS: "LICENSE_EDIT_SUCCESS",
  GET_RESELLERLICENSE_LIST_BYID: "GET_RESELLERLICENSE_LIST_BYID",
  SUCCESS_GET_RESELLERLICENSE_LIST_BYID:
    "SUCCESS_GET_RESELLERLICENSE_LIST_BYID",
  ERROR_GET_RESELLERLICENSE_LIST_BYID: "ERROR_GET_RESELLERLICENSE_LIST_BYID",
  SET_LICENSE_LIST_DATA: "SET_LICENSE_LIST_DATA",
  CLEAR_LICENSE_ITEM: "CLEAR_LICENSE_ITEM",
  GET_RESELLERLICENSE_CUSTOMER_VIEW: "GET_RESELLERLICENSE_CUSTOMER_VIEW",
  SUCCESS_GET_RESELLERLICENSE_CUSTOMER_VIEW:
    "SUCCESS_GET_RESELLERLICENSE_CUSTOMER_VIEW",
  ERROR_GET_RESELLERLICENSE_CUSTOMER_VIEW:
    "ERROR_GET_RESELLERLICENSE_CUSTOMER_VIEW",
};

export const customReports = {
  GET_CUSTOM_FILTER_REQUEST: "GET_CUSTOM_FILTER_REQUEST",
  GET_CUSTOM_FILTER_SUCCESS: "GET_CUSTOM_FILTER_SUCCESS",
  GET_CUSTOM_FILTER_FAILURE: "GET_CUSTOM_FILTER_FAILURE",
  GET_CUSTOM_REPORT_REQUEST: "GET_CUSTOM_REPORT_REQUEST",
  GET_CUSTOM_REPORT_SUCCESS: "GET_CUSTOM_REPORT_SUCCESS",
  GET_CUSTOM_REPORT_RESET: "GET_CUSTOM_REPORT_RESET",
  GET_CUSTOM_REPORT_REQUEST_ALL_DATA: "GET_CUSTOM_REPORT_REQUEST_ALL_DATA",
  GET_CUSTOM_REPORT_ALL_DATA_SUCCESS: "GET_CUSTOM_REPORT_ALL_DATA_SUCCESS",
  GET_CUSTOM_REPORT_FAILURE: "GET_CUSTOM_REPORT_FAILURE",
};

export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";
export const SIGNIN_USER = "SIGNIN_USER";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNOUT_USER = "SIGNOUT_USER";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const INIT_URL = "INIT_URL";
export const USER_DATA = "USER_DATA";
export const USER_DATA_GET = "USER_DATA_GET";
export const USER_TOKEN_SET = "USER_TOKEN_SET";
export const USER_SIGNIN_FAILED = "USER_SIGNIN_FAILED";

export const applicationURL = process?.env?.REACT_APP_API_ENDPOINT
  ? `${process.env.REACT_APP_API_ENDPOINT}/mmlpocadoutlook.onmicrosoft.com`
  : "https://dev.makemylabs.in/mmlpocadoutlook.onmicrosoft.com";
